<template>
  <div v-frag class="materia-detalle">
    <CardIeaAppMain colorCard="#2D3436" title="">
      <v-col cols="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>mdi-keyboard-backspace</v-icon>
        </v-btn>
        <br /><br />

        <v-row class="materia-layout">
          <v-col cols="12" md="3" order="1" order-md="1">
            <v-card class="glass-card rounded-huge overflow-hidden mb-3">
              <div
                class="pa-4 primary white--text font-weight-bold text-uppercase letter-spacing-1"
                style="font-size: 0.85rem;"
              >
                <v-icon left color="white" small
                  >mdi-view-module-outline</v-icon
                >
                Módulos
              </div>
              <div v-if="clasesLoading" class="pa-6 text-center">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="24"
                ></v-progress-circular>
              </div>
              <div
                v-else-if="clasesError"
                class="pa-4 text-caption error--text"
              >
                {{ clasesError }}
              </div>
              <div
                v-else-if="!clasesMateria.length"
                class="pa-4 text-caption grey--text"
              >
                No hay clases disponibles.
              </div>
              <div v-else class="modulos-scroll pa-2">
                <!-- Régimen Académico (Pastilla) -->
                <div class="mb-2">
                  <div
                    class="modulo-header rounded-lg d-flex align-center"
                    :class="{ 'disabled-card': !pastilla }"
                    @click="pastilla ? abrirPastilla() : null"
                  >
                    <v-icon
                      left
                      small
                      class="mr-2"
                      :color="pastilla ? 'success' : 'grey'"
                      >mdi-text-box-search-outline</v-icon
                    >
                    <span class="text-truncate">Régimen Académico</span>
                  </div>
                </div>

                <div
                  v-for="(clase, i) in clasesMateria"
                  :key="clase.id || 'resumen-' + i"
                  class="mb-2"
                >
                  <div
                    class="modulo-header rounded-lg"
                    :class="{
                      'modulo-header-active': selectedClaseIndex === i,
                      'modulo-header-resumen': clase.isResumen
                    }"
                    @click="seleccionarClase(i)"
                  >
                    <v-icon v-if="clase.isResumen" left small
                      >mdi-file-pdf-box</v-icon
                    >
                    <span class="text-truncate">{{ clase.nombre }}</span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col
            :key="`panel-central-${panelCentralRenderKey}`"
            cols="12"
            md="6"
            order="2"
            order-md="2"
          >
            <v-card class="glass-card rounded-huge overflow-hidden">
              <div
                class="hero mb-0 d-flex align-center justify-center"
                style="background: linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%); min-height: 120px;"
              >
                <h2
                  class="white--text text-center px-6 text-h5 font-weight-bold"
                >
                  {{ tituloCurso }}
                </h2>
              </div>
              <div class="course-title-row mb-2">
                <div class="course-name">{{ tituloCurso }}</div>
                <div class="d-flex flex-wrap align-center" style="gap: 8px;">
                  <v-btn
                    v-if="pdfClaseActualUrl"
                    small
                    depressed
                    color="error"
                    class="detail-pdf-btn"
                    @click="descargarPdfClaseActual"
                  >
                    <v-icon left small>mdi-file-pdf-box</v-icon>
                    PDF materia
                  </v-btn>
                  <v-btn
                    small
                    depressed
                    class="detail-cta-btn"
                    @click="abrirDetalleClase"
                  >
                    <v-icon left small>mdi-notebook-open-variant</v-icon>
                    Explorar clase completa
                  </v-btn>
                </div>
              </div>

              <div class="d-flex justify-space-between mb-3 course-nav">
                <v-btn
                  small
                  outlined
                  color="primary"
                  class="course-nav-btn"
                  :disabled="!anteriorDisponible"
                  @click="irAnteriorContenido"
                >
                  Anterior
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  depressed
                  class="course-nav-btn"
                  :disabled="!siguienteDisponible"
                  @click="irSiguienteContenido"
                >
                  Siguiente
                </v-btn>
              </div>

              <v-responsive
                v-if="!mostrarActividades && videosClaseSeleccionada.length"
                class="video-main black rounded-lg mb-4"
                :aspect-ratio="16 / 7"
              >
                <div
                  class="d-flex align-center justify-center fill-height video-main-container"
                >
                  <youtube
                    v-if="currentVideoId"
                    :video-id="currentVideoId"
                    width="100%"
                    ref="youtube"
                    @ready="onVideoReady"
                    @playing="onVideoPlaying"
                    @paused="onVideoPaused"
                    @ended="onVideoEnded"
                  />
                  <!-- Videos nuevos: URL directa (DigitalOcean Spaces) en vez de
                       un id de YouTube. Mismos handlers, mismo tracking. -->
                  <video
                    v-else-if="currentVideoUrl"
                    :src="currentVideoUrl"
                    ref="videoHtml"
                    width="100%"
                    preload="metadata"
                    controls
                    playsinline
                    @loadedmetadata="onVideoReady"
                    @playing="onVideoPlaying"
                    @pause="onVideoPaused"
                    @ended="onVideoEnded"
                  />
                  <v-icon v-else color="white" size="82"
                    >mdi-play-circle-outline</v-icon
                  >
                </div>
              </v-responsive>

              <v-card
                v-if="
                  !mostrarActividades &&
                    claseSeleccionada &&
                    videosClaseSeleccionada.length
                "
                outlined
                class="pa-3 mb-4"
              >
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="text-subtitle-1 font-weight-bold">
                    Videos de {{ claseSeleccionada.nombre }}
                  </div>
                  <v-chip x-small label color="primary" text-color="white">
                    {{ videosClaseSeleccionada.length }} videos
                  </v-chip>
                </div>
                <v-list dense class="pa-0">
                  <v-list-item
                    v-for="(video, idx) in videosClaseSeleccionada"
                    :key="video.id || idx"
                    :class="{ 'video-item-active': selectedVideoIndex === idx }"
                    @click="seleccionarVideo(idx)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        Video {{ idx + 1 }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        class="d-flex align-center justify-space-between"
                      >
                        <span>{{ etapaProgresoVideo(video.porcentaje) }}</span>
                        <span>{{ video.porcentaje }}%</span>
                      </v-list-item-subtitle>
                      <v-progress-linear
                        class="mt-1"
                        height="8"
                        rounded
                        :value="video.porcentaje"
                        :color="colorProgresoVideo(video.porcentaje)"
                      />
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>


              <!-- MATERIAL ADICIONAL DEL PROFESOR -->
              <v-card v-if="!mostrarActividades && materialesClaseSeleccionada.length" outlined class="pa-3 mb-4">
                <div class="text-subtitle-1 font-weight-bold mb-2">
                  Material adicional del profesor
                </div>
                <v-row dense>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    v-for="mat in materialesClaseSeleccionada"
                    :key="mat.id"
                  >
                    <v-card class="pa-2" outlined ripple :href="mat.url" target="_blank" height="100%">
                      <div class="d-flex align-center">
                        <v-icon
                          large
                          class="mr-2"
                          :color="mat.tipo === 'video' ? 'error' : (mat.tipo === 'pdf' ? 'red darken-2' : 'primary')"
                        >
                          {{ mat.tipo === 'video' ? 'mdi-youtube' : (mat.tipo === 'pdf' ? 'mdi-file-pdf-box' : 'mdi-link') }}
                        </v-icon>
                        <div>
                          <div class="text-caption font-weight-bold line-clamp-1">
                            {{ mat.titulo }}
                          </div>
                          <div class="text-overline grey--text" style="line-height: 1;">
                            {{ mat.tipo.toUpperCase() }}
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>

              <!-- CARD ACTIVIDADES LEGADO -->
              <v-card v-if="mostrarActividades" outlined class="pa-3 mb-3 grey lighten-4">
                <div class="text-subtitle-2 mb-2 grey--text text--darken-2 px-2">Módulo de Repaso (Legacy)</div>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    v-for="(actividad, idx) in actividades"
                    :key="'leg-'+idx"
                  >
                    <v-card class="actividad-card" outlined>
                      <div class="actividad-header">{{ actividad.titulo }}</div>
                      <v-card-text class="pt-3">
                        <div class="text-body-2 mb-2">{{ actividad.descripcion }}</div>

                        <template v-if="actividad.tipo === 'arrastrar'">
                          <div class="mb-3">
                            <div class="text-caption font-weight-bold mb-2">Arrastra los conceptos:</div>
                            <div class="d-flex flex-wrap">
                              <v-chip
                                v-for="(item, i) in actividad.disponibles"
                                :key="i"
                                small
                                class="mr-2 mb-2 draggable-chip"
                                color="primary"
                                dark
                                draggable="true"
                                @dragstart="onDragStart(item)"
                              >
                                {{ item }}
                              </v-chip>
                            </div>
                          </div>

                          <div
                            v-for="(item, i) in actividad.items"
                            :key="'drop-' + i"
                            class="drop-row mb-2"
                            @dragover.prevent
                            @drop="onDrop(actividad, i)"
                          >
                            <div class="text-caption grey--text mb-1">{{ item.definicion }}</div>
                            <div class="drop-slot d-flex align-center justify-space-between">
                              <span v-if="actividad.respuestas[i]" class="font-weight-medium">{{ actividad.respuestas[i] }}</span>
                              <span v-else class="grey--text text--darken-1">Suelta aquí</span>
                              <v-btn v-if="actividad.respuestas[i]" icon x-small @click="quitarRespuesta(actividad, i)">
                                <v-icon x-small>mdi-close</v-icon>
                              </v-btn>
                            </div>
                          </div>
                          <div class="mt-2">
                            <v-btn small color="primary" depressed class="mr-2" @click="verificarArrastrar(actividad)">Verificar</v-btn>
                            <v-btn small outlined color="primary" @click="reiniciarArrastrar(actividad)">Reiniciar</v-btn>
                          </div>
                        </template>

                        <template v-else-if="actividad.tipo === 'cuestionario'">
                          <v-radio-group v-model="actividad.answer" dense class="mt-0">
                            <v-radio v-for="(op, i) in actividad.opciones" :key="i" :label="op" :value="op" />
                          </v-radio-group>
                          <v-btn small color="primary" depressed class="mt-2" @click="verificarCuestionario(actividad)">Verificar</v-btn>
                        </template>

                        <div v-if="actividad.resultado" class="text-caption mt-2 font-weight-bold">{{ actividad.resultado }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>

              <!-- CARD ACTIVIDADES INTERACTIVAS (NUEVO MÓDULO) -->
              <v-card v-if="actividadesInteractivas.length" outlined class="pa-3 mb-3 blue lighten-5">
                <div class="text-subtitle-2 mb-2 primary--text px-2 d-flex align-center">
                  <v-icon x-small color="primary" class="mr-1">mdi-star</v-icon>
                  Nuevo Módulo de Actividades Educativas
                </div>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    v-for="(actividad, idx) in actividadesInteractivas"
                    :key="'int-'+idx"
                  >
                    <v-card class="actividad-card" outlined>
                      <div class="actividad-header d-flex justify-space-between align-center">
                        <span>{{ actividad.title }}</span>
                        <v-chip x-small label color="white" class="primary--text" v-if="etiquetaTipo(actividad)">
                          {{ etiquetaTipo(actividad) }}
                        </v-chip>
                      </div>
                      <v-card-text class="pt-3">
                        <div class="text-body-2 mb-3" v-html="actividad.content"></div>
                        <div v-if="consignaTipo(actividad)" class="text-caption grey--text text--darken-1 mb-3">
                          <v-icon x-small class="mr-1">mdi-information-outline</v-icon>
                          {{ consignaTipo(actividad) }}
                        </div>

                        <!-- 1. SINGLE_CHOICE / 3. TRUE_FALSE -->
                        <template v-if="actividad.type === 'SINGLE_CHOICE' || actividad.type === 'TRUE_FALSE'">
                          <v-radio-group v-model="respuestasActividades[actividad.id]" dense>
                            <v-radio
                              v-for="opcion in getOpciones(actividad)"
                              :key="opcion.id"
                              :label="opcion.text"
                              :value="opcion.id"
                            />
                          </v-radio-group>
                        </template>

                        <!-- 2. MULTIPLE_CHOICE -->
                        <template v-else-if="actividad.type === 'MULTIPLE_CHOICE'">
                          <div v-for="opcion in getOpciones(actividad)" :key="opcion.id">
                            <v-checkbox
                              v-model="respuestasActividades[actividad.id]"
                              :label="opcion.text"
                              :value="opcion.id"
                              hide-details
                              dense
                              multiple
                            />
                          </div>
                        </template>

                        <!-- 4. DEVELOPMENT -->
                        <template v-else-if="actividad.type === 'DEVELOPMENT'">
                          <v-textarea
                            v-model="respuestasActividades[actividad.id]"
                            outlined
                            dense
                            placeholder="Escribe tu respuesta aquí..."
                          />
                        </template>

                        <!-- 5. MATCHING -->
                        <template v-else-if="actividad.type === 'MATCHING'">
                          <v-row dense v-for="l in getMatchingPairs(actividad).left" :key="l.id" class="align-center mb-2">
                            <v-col cols="5">
                              <v-sheet class="pa-2 grey lighten-4 rounded text-caption">{{ l.text }}</v-sheet>
                            </v-col>
                            <v-col cols="2" class="text-center">
                              <v-icon small>mdi-swap-horizontal</v-icon>
                            </v-col>
                            <v-col cols="5">
                              <v-select
                                v-model="getMatchingPairs(actividad).matches[l.id]"
                                :items="getMatchingPairs(actividad).right"
                                item-text="text"
                                item-value="id"
                                dense
                                outlined
                                hide-details
                                label="Seleccionar"
                                class="text-caption"
                              />
                            </v-col>
                          </v-row>
                        </template>

                        <!-- 6. SEQUENCING -->
                        <template v-else-if="actividad.type === 'SEQUENCING'">
                          <v-list dense class="pa-0 grey lighten-5 rounded">
                            <v-list-item v-for="(op, i) in getOpciones(actividad)" :key="op.id" class="border-bottom">
                              <v-list-item-content class="text-caption">{{ op.text }}</v-list-item-content>
                              <v-list-item-action class="flex-row">
                                <v-btn icon x-small @click="moveSequence(actividad, i, -1)" :disabled="i === 0">
                                  <v-icon>mdi-chevron-up</v-icon>
                                </v-btn>
                                <v-btn icon x-small @click="moveSequence(actividad, i, 1)" :disabled="i === getOpciones(actividad).length - 1">
                                  <v-icon>mdi-chevron-down</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </template>

                        <!-- 7. NUMERIC -->
                        <template v-else-if="actividad.type === 'NUMERIC'">
                          <v-text-field
                            v-model="respuestasActividades[actividad.id]"
                            type="number"
                            outlined
                            dense
                            label="Ingresa un número"
                          />
                        </template>

                        <!-- 8. FILL_IN_THE_BLANK -->
                        <template v-else-if="actividad.type === 'FILL_IN_THE_BLANK'">
                          <div class="text-body-2 fill-blank-container">
                            <template v-for="(part, pidx) in parseFillInTheBlank(actividad.content)">
                              <span :key="'p'+pidx" v-html="part"></span>
                              <input
                                v-if="pidx < parseFillInTheBlank(actividad.content).length - 1"
                                :key="'i'+pidx"
                                v-model="respuestasActividades[actividad.id][pidx]"
                                class="blank-input"
                                type="text"
                                placeholder="..."
                              />
                            </template>
                          </div>
                        </template>

                        <!-- Botón Verificar -->
                        <div v-if="actividad.type && actividad.type !== 'DEVELOPMENT'" class="mt-4">
                          <v-btn
                            small
                            color="primary"
                            depressed
                            block
                            :loading="actividad.verificando"
                            @click="verificarActividadScorm(actividad)"
                          >
                            Verificar respuesta
                          </v-btn>
                        </div>

                        <div
                          v-if="actividad.resultado"
                          class="text-caption mt-2 font-weight-bold p-2 rounded"
                          :class="claseResultadoScorm(actividad)"
                        >
                          {{ actividad.resultado }}
                        </div>
                        <div v-if="actividad.resultado && actividad.feedback" class="text-caption mt-1 grey--text text--darken-2 italic">
                          <strong>Feedback:</strong> {{ actividad.feedback }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>

              <v-card outlined class="pa-3">
                <div class="text-h6 mb-3">Recursos del curso</div>
                <div class="recursos-actions mb-3">
                  <v-btn
                    v-if="cursoGoogleDriveUrl"
                    color="primary"
                    class="mr-2 mb-2 recurso-btn"
                    depressed
                    @click="abrirRecursoCurso"
                  >
                    Abrir Google Drive
                  </v-btn>
                  <v-btn
                    v-if="pdfCursoUrl"
                    color="error"
                    class="mr-2 mb-2 recurso-btn"
                    depressed
                    @click="descargarPdfCurso"
                  >
                    Descargar PDF de la clase
                  </v-btn>
                  <div
                    v-if="!cursoGoogleDriveUrl && !pdfCursoUrl"
                    class="text-caption grey--text text--darken-1 mb-2"
                  >
                    No hay recursos PDF o Google Drive para este curso.
                  </div>
                </div>

                <div class="text-h6 mb-3">
                  Preguntas y respuestas de la clase
                </div>
                <div
                  v-if="!claseSeleccionada"
                  class="text-caption grey--text text--darken-1"
                >
                  Selecciona una clase para ver sus preguntas y respuestas.
                </div>
                <div
                  v-else-if="!preguntasRespuestasClase.length"
                  class="text-caption grey--text text--darken-1"
                >
                  No hay preguntas y respuestas para esta clase.
                </div>
                <div v-else>
                  <v-card
                    v-for="item in preguntasRespuestasClase"
                    :key="`pr-${item.id || item.pregunta}`"
                    outlined
                    class="mb-2 pa-3"
                  >
                    <div class="d-flex align-center justify-space-between mb-1">
                      <div class="text-subtitle-2 font-weight-bold">
                        Pregunta
                      </div>
                      <v-chip
                        x-small
                        :color="
                          item.entrega && item.entrega.corregido
                            ? 'success'
                            : item.entrega
                            ? 'orange'
                            : 'grey'
                        "
                        dark
                      >
                        {{
                          item.entrega && item.entrega.corregido
                            ? "Corregido"
                            : item.entrega
                            ? "Entregado"
                            : "Pendiente"
                        }}
                      </v-chip>
                    </div>
                    <div class="text-body-2 mb-2" v-html="item.pregunta"></div>
                    <div class="text-subtitle-2 font-weight-bold mb-1">
                      Consigna
                    </div>
                    <div class="text-body-2 mb-3" v-html="item.respuesta"></div>

                    <div
                      v-if="item.entrega && item.entrega.correccion_comentario"
                      class="text-caption mb-2"
                    >
                      <strong>Comentario docente:</strong>
                      {{ item.entrega.correccion_comentario }}
                    </div>
                    <div
                      v-if="actividadBloqueadaPorIa(item)"
                      class="text-caption success--text mb-2"
                    >
                      La IA validó tu respuesta como correcta. Esta respuesta
                      queda bloqueada para edición.
                    </div>

                    <template v-if="item.tipo === 'subida_pdf'">
                      <v-file-input
                        accept=".pdf,application/pdf"
                        outlined
                        dense
                        show-size
                        label="Adjuntar trabajo en PDF"
                        :disabled="
                          Boolean(item.entrega && item.entrega.corregido)
                        "
                        @change="onSeleccionarArchivoActividad(item, $event)"
                      />
                      <div
                        v-if="item.entrega && item.entrega.archivo_url"
                        class="text-caption mb-2"
                      >
                        Archivo actual:
                        <a
                          :href="item.entrega.archivo_url"
                          target="_blank"
                          rel="noopener"
                        >
                          {{ item.entrega.archivo_nombre || "Ver archivo" }}
                        </a>
                      </div>
                      <div class="d-flex justify-end mt-2">
                        <v-btn
                          small
                          color="primary"
                          depressed
                          :disabled="
                            Boolean(item.entrega && item.entrega.corregido)
                          "
                          @click="enviarPdfActividad(item)"
                        >
                          Enviar PDF
                        </v-btn>
                      </div>
                    </template>
                    <template v-else>
                      <v-textarea
                        :value="obtenerRespuestaAlumno(item)"
                        outlined
                        dense
                        no-resize
                        rows="4"
                        label="Tu respuesta"
                        placeholder="Escribe aquí tu respuesta..."
                        :disabled="!puedeEditarActividad(item)"
                        @input="actualizarRespuestaAlumno(item, $event)"
                      />
                      <div class="text-caption grey--text text--darken-1 mt-1">
                        {{ contarCaracteresRespuesta(item) }}/{{
                          minimoCaracteresRespuesta(item)
                        }}
                        caracteres mínimos
                      </div>
                      <div class="d-flex justify-end mt-2">
                        <v-btn
                          small
                          color="primary"
                          depressed
                          :disabled="!puedeEditarActividad(item)"
                          @click="enviarRespuestaActividad(item)"
                        >
                          {{
                            esActividadIa(item)
                              ? "Validar con IA"
                              : "Guardar respuesta"
                          }}
                        </v-btn>
                      </div>
                      <div
                        v-if="obtenerMensajeActividad(item)"
                        class="text-caption mt-2"
                        :class="colorMensajeActividad(item)"
                      >
                        {{ obtenerMensajeActividad(item) }}
                      </div>
                      <div
                        v-if="item.entrega && item.entrega.ia_devolucion"
                        class="text-caption mt-2"
                      >
                        <strong>Devolución IA:</strong>
                        {{ item.entrega.ia_devolucion }}
                      </div>
                      <div
                        v-if="item.entrega && item.entrega.ia_consejo"
                        class="text-caption mt-1"
                      >
                        <strong>Consejo IA:</strong>
                        {{ item.entrega.ia_consejo }}
                      </div>
                      <v-chip
                        v-if="
                          item.entrega &&
                            item.entrega.ia_correcta !== null &&
                            item.entrega.ia_correcta !== undefined
                        "
                        x-small
                        class="mt-2"
                        :color="
                          normalizarBooleano(item.entrega.ia_correcta)
                            ? 'success'
                            : 'warning'
                        "
                        dark
                      >
                        {{
                          normalizarBooleano(item.entrega.ia_correcta)
                            ? "Validación IA: correcta"
                            : "Validación IA: revisar respuesta"
                        }}
                      </v-chip>
                    </template>
                  </v-card>
                </div>
              </v-card>

              <v-card class="foro-card mt-3" dark>
                <v-card-text class="d-flex align-center py-3 px-4">
                  <v-icon class="mr-2">mdi-forum-outline</v-icon>
                  <span class="font-weight-bold">Foro de Discusión</span>
                </v-card-text>
              </v-card>
              <v-card outlined class="pa-3 mt-2">
                <div
                  class="d-flex align-center justify-space-between mb-2 foro-header"
                >
                  <div class="text-subtitle-1 font-weight-bold">
                    Temas de la materia
                  </div>
                  <v-btn
                    small
                    color="primary"
                    depressed
                    @click="abrirDialogForoNuevo"
                  >
                    Nuevo tema
                  </v-btn>
                </div>

                <div v-if="foroLoading" class="text-caption grey--text">
                  Cargando foros...
                </div>
                <div v-else-if="foroError" class="text-caption error--text">
                  {{ foroError }}
                </div>

                <div v-else-if="foroSeleccionado">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div class="font-weight-bold">
                      {{ foroSeleccionado.title }}
                    </div>
                    <v-btn
                      x-small
                      text
                      color="primary"
                      @click="foroSeleccionado = null"
                      >Volver</v-btn
                    >
                  </div>
                  <div
                    class="text-caption mb-2"
                    :style="{
                      color: foroSeleccionado.category?.color || '#777'
                    }"
                  >
                    {{ foroSeleccionado.category?.name || "Sin sección" }}
                  </div>
                  <div
                    class="text-body-2 mb-3"
                    v-html="foroSeleccionado.content"
                  ></div>
                  <div class="d-flex flex-wrap mb-3" v-if="imagenesForo(foroSeleccionado).length">
                    <a
                      v-for="img in imagenesForo(foroSeleccionado)"
                      :key="img.id"
                      :href="img.image"
                      target="_blank"
                      rel="noopener"
                      class="mr-2 mb-2"
                    >
                      <v-img :src="img.image" width="120" height="120" class="rounded-lg" />
                    </a>
                  </div>
                  <div class="d-flex align-center mb-3">
                    <v-btn icon small @click="likeForo(foroSeleccionado)">
                      <v-icon small>mdi-thumb-up-outline</v-icon>
                    </v-btn>
                    <span class="text-caption mr-2">{{
                      foroSeleccionado.likes || 0
                    }}</span>
                    <v-btn icon small @click="dislikeForo(foroSeleccionado)">
                      <v-icon small>mdi-thumb-down-outline</v-icon>
                    </v-btn>
                  </div>
                  <v-textarea
                    v-model="foroComentario"
                    rows="2"
                    outlined
                    dense
                    label="Escribe un comentario"
                    class="mb-2"
                  />
                  <v-btn
                    small
                    color="primary"
                    depressed
                    @click="enviarComentarioForo"
                    >Comentar</v-btn
                  >

                  <div
                    v-if="
                      Array.isArray(foroSeleccionado.comments) &&
                        foroSeleccionado.comments.length
                    "
                    class="mt-3"
                  >
                    <div
                      v-for="(comment, idx) in foroSeleccionado.comments"
                      :key="comment.id || idx"
                      class="mb-2 pa-2"
                      style="border: 1px solid #eceff1; border-radius: 8px;"
                    >
                      <div class="text-caption grey--text d-flex justify-space-between">
                        <span>{{ getAutorForo(comment) }}</span>
                        <span>{{ getFechaRelativa(comment.created_at) }}</span>
                      </div>
                      <div class="text-body-2" v-html="comment.comment"></div>
                    </div>
                  </div>
                  <div v-else class="text-caption grey--text mt-3">
                    Sin comentarios aún.
                  </div>
                </div>

                <div
                  v-else-if="!forosMateria.length"
                  class="text-caption grey--text"
                >
                  No hay temas para esta materia.
                </div>

                <div v-else>
                  <div
                    v-for="(foro, idx) in forosMateria"
                    :key="foro.id || idx"
                    class="mb-2 pa-2 foro-item"
                    style="border: 1px solid #eceff1; border-radius: 8px; cursor: pointer;"
                    @click="abrirForoDetalle(foro)"
                  >
                    <div class="text-body-2 font-weight-bold">
                      {{ foro.title }}
                    </div>
                    <div
                      class="text-caption"
                      :style="{ color: foro.category?.color || '#777' }"
                    >
                      {{ foro.category?.name || "Sin sección" }}
                    </div>
                    <div class="text-caption grey--text d-flex justify-space-between">
                      <span>
                        {{ (foro.comments || []).length }} comentarios -
                        {{ foro.likes || 0 }} likes
                      </span>
                      <span>{{ getFechaRelativa(foro.created_at) }}</span>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-card>
          </v-col>

          <v-col cols="12" md="3" order="3" order-md="3">
            <v-card
              v-if="tieneMeet"
              class="rounded-huge glass-card mb-4 meet-card pa-4"
              @click="abrirMeet"
            >
              <div class="d-flex align-center">
                <v-avatar color="red lighten-5" size="48" class="mr-4">
                  <v-icon color="error">mdi-video-outline</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-subtitle-1 font-weight-bold mb-0"
                    style="line-height: 1.2;"
                  >
                    Clase en Vivo
                  </div>
                  <div class="text-caption grey--text">
                    Google Meet
                  </div>
                </div>
                <v-spacer></v-spacer>
                <v-icon color="error">mdi-chevron-right</v-icon>
              </div>
            </v-card>
            <v-card
              v-if="claseSeleccionada"
              class="rounded-huge glass-card mb-4 guia-card pa-4"
              @click="abrirGuia"
            >
              <div class="d-flex align-center">
                <v-avatar color="blue lighten-5" size="48" class="mr-4">
                  <v-icon color="primary"
                    >mdi-book-open-page-variant-outline</v-icon
                  >
                </v-avatar>
                <div>
                  <div
                    class="text-subtitle-1 font-weight-bold mb-0"
                    style="line-height: 1.2;"
                  >
                    Guía de Contenido
                  </div>
                  <div class="text-caption grey--text">
                    Material de apoyo
                  </div>
                </div>
                <v-spacer></v-spacer>
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </div>
            </v-card>
            <v-card v-if="adjuntosClaseSeleccionada.length" class="pa-3 mb-3">
              <div class="d-flex align-center mb-2">
                <v-icon color="primary" class="mr-2">mdi-paperclip</v-icon>
                <div class="text-h6">Documentos de la clase</div>
              </div>
              <div class="text-caption grey--text text--darken-1 mb-2">
                {{ claseSeleccionada ? claseSeleccionada.nombre : "" }}
              </div>
              <v-card
                v-for="adjunto in adjuntosClaseSeleccionada"
                :key="adjunto.id"
                class="pa-2 mb-2"
                outlined
                ripple
                :href="adjunto.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div class="d-flex align-center">
                  <v-icon class="mr-2" :color="colorAdjunto(adjunto.nombre)">
                    {{ iconoAdjunto(adjunto.nombre) }}
                  </v-icon>
                  <div class="text-caption font-weight-bold line-clamp-1">
                    {{ adjunto.nombre }}
                  </div>
                  <v-spacer></v-spacer>
                  <v-icon small color="grey">mdi-download</v-icon>
                </div>
              </v-card>
            </v-card>

            <v-card class="pa-3 mb-3">
              <div class="text-h6 mb-2">Progreso del Curso</div>
              <div class="text-body-2 mb-2">{{ progreso }}% completado</div>
              <v-progress-linear
                :value="progreso"
                :color="colorCurso"
                rounded
              />
            </v-card>

            <v-card class="pa-3 mb-3">
              <div class="d-flex align-center mb-2">
                <v-icon color="primary" class="mr-2">mdi-school-outline</v-icon>
                <div class="text-h6">Asistente Académico IA</div>
              </div>
              <div class="text-caption grey--text text--darken-1 mb-2">
                Haz preguntas sobre el contenido, conceptos y ejercicios del
                módulo.
              </div>
              <v-textarea
                v-model="iaQuestion"
                placeholder="Ejemplo: ¿Cuál es la diferencia entre variable y constante?"
                rows="3"
                outlined
                dense
                :disabled="iaLoading"
              />
              <v-btn
                color="primary"
                block
                depressed
                :loading="iaLoading"
                @click="preguntarIA"
                >Preguntar</v-btn
              >
              <div v-if="iaError" class="error--text text-caption mt-2">
                {{ iaError }}
              </div>

              <v-skeleton-loader v-if="iaLoading" class="mt-3" type="article" />

              <div v-if="iaReply && !iaLoading" class="mt-3 ia-chat-wrap">
                <div class="ia-bubble ia-bubble-user mb-2">
                  <div class="text-caption font-weight-bold mb-1">
                    Tu pregunta
                  </div>
                  <div class="text-body-2">{{ iaLastQuestion }}</div>
                </div>

                <div class="ia-bubble ia-bubble-assistant">
                  <div class="d-flex align-center justify-space-between mb-1">
                    <div class="text-caption font-weight-bold">
                      Respuesta recomendada
                    </div>
                    <v-chip x-small color="primary" text-color="white" label>{{
                      iaModelLabel
                    }}</v-chip>
                  </div>
                  <div class="text-body-2 ia-reply-text">{{ iaReply }}</div>
                </div>
              </div>
            </v-card>

            <v-card
              class="rounded-huge glass-card mt-4 bibliografia-card pa-4"
              :class="{ 'disabled-card': !bibliografia }"
              @click="bibliografia ? abrirBibliografia() : null"
            >
              <div class="d-flex align-center">
                <v-avatar
                  :color="bibliografia ? 'green lighten-5' : 'grey lighten-4'"
                  size="48"
                  class="mr-4"
                >
                  <v-icon :color="bibliografia ? 'success' : 'grey'"
                    >mdi-library-books</v-icon
                  >
                </v-avatar>
                <div>
                  <div
                    class="text-subtitle-1 font-weight-bold mb-0"
                    style="line-height: 1.2;"
                  >
                    Bibliografía
                  </div>
                  <div class="text-caption grey--text">
                    {{ bibliografia ? "Material sugerido" : "No disponible" }}
                  </div>
                </div>
                <v-spacer></v-spacer>
                <v-icon :color="bibliografia ? 'success' : 'grey'"
                  >mdi-chevron-right</v-icon
                >
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>

    <!-- DIALOGO: BIBLIOGRAFÍA -->
    <v-dialog v-model="bibliografiaDialog" max-width="850px" scrollable>
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat dark color="primary" class="px-4">
          <v-icon left>mdi-library-books</v-icon>
          <v-toolbar-title class="font-weight-bold ml-2">
            Bibliografía de la Cátedra
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="bibliografiaDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6" style="max-height: 70vh;">
          <div
            class="bibliografia-html text-body-1"
            v-html="bibliografia"
          ></div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-6 py-3">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="bibliografiaDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGO: REGIMEN ACADEMICO (PASTILLA) -->
    <v-dialog v-model="pastillaDialog" max-width="850px" scrollable>
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat dark color="success" class="px-4">
          <v-icon left>mdi-text-box-search-outline</v-icon>
          <v-toolbar-title class="font-weight-bold ml-2">
            Régimen Académico (Pastilla)
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="pastillaDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6" style="max-height: 70vh;">
          <div class="bibliografia-html text-body-1" v-html="pastilla"></div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-6 py-3">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="pastillaDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showForoForm" max-width="600px">
      <v-card class="rounded-xl overflow-hidden">
        <v-toolbar flat dark color="primary" class="px-2">
          <v-toolbar-title class="font-weight-bold">
            <v-icon left>mdi-plus-circle-outline</v-icon>
            Nuevo tema de discusión
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showForoForm = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-6">
          <div class="text-subtitle-2 mb-1 grey--text text--darken-1">Título del tema</div>
          <v-text-field
            v-model="foroForm.title"
            placeholder="¿Sobre qué quieres hablar?"
            outlined
            hide-details
            class="mb-4 rounded-lg"
            background-color="grey lighten-5"
          />
          <div class="text-subtitle-2 mb-1 grey--text text--darken-1">Sección o Categoría</div>
          <v-select
            v-model="foroForm.categoryId"
            :items="foroCategoriasMateria"
            item-text="name"
            item-value="id"
            placeholder="Selecciona una sección"
            outlined
            hide-details
            class="mb-4 rounded-lg"
            background-color="grey lighten-5"
          >
            <template v-slot:item="{ item }">
              <v-icon :color="item.color || 'primary'" small class="mr-2">mdi-label</v-icon>
              {{ item.name }}
            </template>
          </v-select>
          <div class="text-subtitle-2 mb-1 grey--text text--darken-1">Contenido</div>
          <v-textarea
            v-model="foroForm.content"
            placeholder="Describe tu duda o comentario..."
            outlined
            rows="5"
            hide-details
            class="rounded-lg"
            background-color="grey lighten-5"
          />
          <v-file-input
            v-model="foroForm.imagenes"
            accept="image/*"
            multiple
            chips
            small-chips
            prepend-icon="mdi-file-image-plus"
            label="Imágenes (opcional)"
            outlined
            hide-details
            class="mt-4 rounded-lg"
            background-color="grey lighten-5"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="showForoForm = false" class="text-capitalize">Cancelar</v-btn>
          <v-btn 
            color="primary" 
            depressed 
            class="px-6 rounded-lg text-capitalize"
            @click="guardarForoNuevo"
          >
            Publicar tema
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showClaseDetalleDialog" max-width="900px">
      <v-card>
        <v-card-title class="d-flex align-center justify-space-between">
          <span
            >Detalle de
            {{
              claseSeleccionada ? claseSeleccionada.nombre : "la clase"
            }}</span
          >
          <v-btn icon @click="showClaseDetalleDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            v-if="claseDetalleLoading"
            class="text-caption grey--text text--darken-1"
          >
            Cargando detalle de la clase...
          </div>
          <div v-else-if="claseDetalleError" class="text-caption error--text">
            {{ claseDetalleError }}
          </div>
          <div
            v-else-if="claseDetalleHtml"
            class="clase-detalle-html"
            v-html="claseDetalleHtml"
          />
          <div v-else class="text-caption grey--text text--darken-1">
            Esta clase no tiene detalle disponible.
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="showClaseDetalleDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOGO: GUÍA DE CONTENIDO (PREMIUM) -->
    <v-dialog v-model="guiaDialog" max-width="850px" scrollable>
      <v-card class="guia-dialog-card">
        <v-card-title class="guia-header py-4 px-6 d-flex align-center">
          <v-icon large color="white" class="mr-3">mdi-book-open-page-variant</v-icon>
          <div>
            <div class="text-h5 white--text font-weight-bold">Guía de Contenidos</div>
            <div v-if="guiaContenido" class="text-caption white--text op-80">
              {{ guiaContenido.materia }} | Código: {{ guiaContenido.codigo }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="guiaDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <div v-if="guiaLoading" class="d-flex flex-column align-center justify-center py-10">
            <v-progress-circular indeterminate color="primary" size="64" class="mb-4"></v-progress-circular>
            <div class="text-subtitle-1 grey--text">Cargando guía educativa...</div>
          </div>

          <div v-else-if="guiaError" class="pa-10 text-center">
            <v-icon color="error" size="64">mdi-alert-circle-outline</v-icon>
            <div class="text-h6 error--text mt-4">{{ guiaError }}</div>
            <v-btn color="primary" depressed class="mt-4" @click="abrirGuia">Reintentar</v-btn>
          </div>

          <div v-else-if="guiaContenido" class="guia-content pa-6">
            <div class="guia-table-wrapper">
              <table class="guia-table">
                <thead>
                  <tr>
                    <th class="text-center" style="width: 100px;">N° CLASE</th>
                    <th class="text-left">CONTENIDOS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tema in guiaContenido.temas" :key="tema.numero">
                    <td class="text-center font-weight-bold guia-numero-cell">
                      {{ tema.numero }}
                    </td>
                    <td class="guia-tema-cell">
                      <div class="text-subtitle-1 font-weight-bold mb-2 tema-titulo">
                        {{ tema.titulo }}
                      </div>
                      <ul class="guia-subtemas-list">
                        <li v-for="(sub, idx) in tema.subtemas" :key="idx" class="mb-1">
                          {{ sub }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4 guia-footer border-top d-flex justify-space-between">
          <v-btn text color="grey darken-1" @click="guiaDialog = false">
            Cerrar
          </v-btn>
          <v-btn
            v-if="guiaContenido"
            color="error"
            dark
            depressed
            class="px-6"
            @click="descargarGuiaPdf"
          >
            <v-icon left>mdi-file-pdf-box</v-icon>
            Descargar PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import abrirArchivo from "../../js/abrirArchivo";
import moment from "moment";
moment.locale('es');

// El backend manda el tipo tal cual lo trae el scorm.json (SINGLE_CHOICE,
// MATCHING...). Al alumno se le muestra en castellano y como consigna, no como
// nombre de tipo.
const TIPOS_ACTIVIDAD = {
  SINGLE_CHOICE: { etiqueta: "Opción única", consigna: "Elegí una opción." },
  MULTIPLE_CHOICE: {
    etiqueta: "Opción múltiple",
    consigna: "Elegí todas las opciones correctas."
  },
  TRUE_FALSE: {
    etiqueta: "Verdadero o falso",
    consigna: "Indicá si la afirmación es verdadera o falsa."
  },
  MATCHING: {
    etiqueta: "Relacionar",
    consigna: "Relacioná cada elemento de la izquierda con el que le corresponde."
  },
  SEQUENCING: {
    etiqueta: "Ordenar",
    consigna: "Ordená los elementos con las flechas."
  },
  FILL_IN_THE_BLANK: {
    etiqueta: "Completar",
    consigna: "Completá los espacios en blanco."
  },
  NUMERIC: { etiqueta: "Respuesta numérica", consigna: "Ingresá un número." },
  DEVELOPMENT: {
    etiqueta: "Desarrollo",
    consigna: "Escribí tu respuesta con tus palabras."
  }
};

export default {
  name: "MateriaDetalle",
  components: { CardIeaAppMain },
  data() {
    return {
      mostrarActividades: false,
      actividades: [],
      actividadesInteractivas: [],
      actividadesScormSeq: 0,
      materialesClase: [],
      actividadesCargando: false,
      clasesMateria: [],
      videosClaseBackendPorId: {},
      actividadesClaseBackendPorId: {},
      materialesClaseBackendPorId: {},
      pdfClaseBackendPorId: {},
      codCatedraReal: "",
      panelCentralRenderKey: 0,
      selectedClaseIndex: 0,
      selectedVideoIndex: 0,
      currentVideoId: null,
      // URL del video cuando NO es de YouTube (link directo de DigitalOcean).
      // Excluyente con currentVideoId: uno u otro, nunca los dos.
      currentVideoUrl: null,
      pendingStartSeconds: 0,
      autoPlayCurrentVideo: true,
      progressInterval: null,
      videosClaseRequestSeq: 0,
      actividadesClaseRequestSeq: 0,
      cambioClaseSeq: 0,
      clasesLoading: false,
      clasesError: "",
      iaQuestion: "",
      iaLastQuestion: "",
      iaReply: "",
      iaModel: "",
      iaApiVersion: "",
      iaError: "",
      iaLoading: false,
      iaHistory: [],
      cursoGoogleDriveUrl: "",
      materiaLinkPdf: "",
      linkMeetMateria: "",
      codClassRoomMateria: "",
      nombreMateria: "",
      actividadClaseSeleccionada: null,
      respuestasAlumnoPorActividad: {},
      archivosActividadPorItem: {},
      respuestasIaBackendPorHash: {},
      mensajesActividadPorClave: {},
      forosMateria: [],
      foroCategoriasMateria: [],
      foroLoading: false,
      foroError: "",
      foroSeleccionado: null,
      foroComentario: "",
      showClaseDetalleDialog: false,
      claseDetalleHtml: "",
      claseDetalleLoading: false,
      claseDetalleError: "",
      showForoForm: false,
      guiaDialog: false,
      guiaLoading: false,
      guiaError: "",
      guiaContenido: null,
      bibliografia: "",
      pastilla: "",
      bibliografiaDialog: false,
      pastillaDialog: false,
      foroForm: {
        title: "",
        content: "",
        categoryId: null,
        imagenes: []
      },
      // Nuevas actividades SCORM
      respuestasActividades: {}, // { actividadId: respuesta }
      shuffledOptionsMap: {}, // { actividadId: options }
      mathjaxLoaded: false
    };
  },
  computed: {
    tituloCurso() {
      return this.nombreMateria || this.$route.query.nombre || "";
    },
    tieneMeet() {
      return Boolean(
        (this.claseSeleccionada && this.claseSeleccionada.link_meet) ||
          this.linkMeetMateria ||
          this.codClassRoomMateria
      );
    },
    colorCurso() {
      return this.$route.query.color || "#1976D2";
    },
    progreso() {
      if (this.clasesMateria.length) {
        const totalClases = this.clasesMateria.length;
        const clasesNoVistas = this.clasesMateria.filter(
          clase => !this.claseFinalizadaParaProgreso(clase)
        ).length;
        const clasesVistas = Math.max(0, totalClases - clasesNoVistas);
        return Math.round((clasesVistas / totalClases) * 100);
      }
      // #395: sin clases no hay avance; antes caía en un 62 % de maqueta.
      return 0;
    },
    claseSeleccionada() {
      if (!this.clasesMateria.length) return null;
      return this.clasesMateria[this.selectedClaseIndex] || null;
    },
    // Era un flag en data que nadie ponia en true, con lo cual los botones de
    // actividades no se renderizaban nunca.
    videosClaseSeleccionada() {
      if (!this.claseSeleccionada) return [];
      return Array.isArray(this.claseSeleccionada.materia_codigo_link)
        ? this.claseSeleccionada.materia_codigo_link
        : [];
    },
    materialesClaseSeleccionada() {
      if (!this.claseSeleccionada) return [];
      return (
        this.materialesClaseBackendPorId[this.claseSeleccionada.id] || []
      );
    },
    adjuntosClaseSeleccionada() {
      if (!this.claseSeleccionada) return [];
      const adjuntos = this.claseSeleccionada.adjuntos;
      // Las clases sinteticas de resumen y los backends viejos no traen la
      // propiedad.
      if (!Array.isArray(adjuntos)) return [];
      return adjuntos.filter(a => a && a.url);
    },
    user() {
      return this.$store.getters.user || {};
    },
    esDocente() {
      return this.user.tipoUsuario === "profesor";
    },
    anteriorDisponible() {
      return Boolean(this.obtenerAnteriorDisponible());
    },
    siguienteDisponible() {
      return Boolean(this.obtenerSiguienteDisponible());
    },
    iaModelLabel() {
      if (!this.iaModel) return "Gemini";
      if (!this.iaApiVersion) return this.iaModel;
      return this.iaModel;
    },
    actividadesClaseDisponibles() {
      if (!this.claseSeleccionada) return [];
      const claseId = this.claseSeleccionada.id;
      const actividadesBackend = this.normalizarActividadesClase(
        claseId ? this.actividadesClaseBackendPorId[claseId] : null
      );
      if (actividadesBackend.length) {
        return actividadesBackend;
      }
      return this.normalizarActividadesClase(
        this.obtenerActividadesClaseRaw(this.claseSeleccionada)
      );
    },
    preguntasRespuestasClase() {
      if (!this.claseSeleccionada) return [];
      const claseId = this.claseSeleccionada.id;
      const backendItems = claseId
        ? this.actividadesClaseBackendPorId[claseId]
        : null;
      const actividadesIa = this.normalizarPreguntasRespuestas(
        this.obtenerActividadesClaseRaw(this.claseSeleccionada),
        "ia"
      ).map(item => ({
        ...item,
        es_creada_profesor: false,
        entrega:
          item.entrega ||
          this.respuestasIaBackendPorHash[item.actividad_hash] ||
          null
      }));
      // Solo se muestran las actividades scorm (tipo_mod = 2); las preguntas
      // viejas de la clase (tipo_mod = 1) quedan ocultas.
      const actividadesBackend = this.normalizarPreguntasRespuestas(
        backendItems,
        "clase"
      ).filter(item => item.tipo_mod !== 1);

      if (!actividadesIa.length) {
        // Si no hay IA, mostrar igual las actividades creadas por clase.
        return actividadesBackend;
      }
      if (!actividadesBackend.length) {
        return actividadesIa;
      }

      // Orden requerido: primero generadas por IA, luego actividades creadas por clase.
      return [...actividadesIa, ...actividadesBackend];
    },
    pdfClaseActualUrl() {
      const pdfMateria = this.normalizarValorPdf(this.materiaLinkPdf);
      return this.resolverUrlActividad(pdfMateria);
    },
    pdfCursoUrl() {
      if (!this.claseSeleccionada) return "";
      const claseId = this.claseSeleccionada.id;
      const pdfBackend = claseId
        ? this.normalizarValorPdf(this.pdfClaseBackendPorId[claseId])
        : "";
      const pdfClase =
        pdfBackend ||
        this.normalizarValorPdf(this.claseSeleccionada.link_pdf) ||
        "";
      return this.resolverUrlActividad(pdfClase);
    }
  },
  watch: {
    actividades: {
      handler() {
        this.triggerMathJax();
      },
      deep: true
    }
  },
  methods: {
    obtenerTurnoCurso() {
      const nombre = String(this.tituloCurso || "").trim();
      if (!nombre.includes("-")) return "";
      const partes = nombre.split("-");
      return String(partes[partes.length - 1] || "").trim();
    },
    normalizarValorPdf(valor) {
      const raw = String(valor || "").trim();
      if (!raw) return "";
      const invalido = raw.toLowerCase();
      if (
        invalido === "null" ||
        invalido === "undefined" ||
        invalido === "false" ||
        invalido === "0"
      ) {
        return "";
      }
      return raw;
    },
    claveRespuestaAlumno(item) {
      const claseId = this.claseSeleccionada?.id || "sin-clase";
      const itemId =
        item?.actividad_hash || item?.id || item?.pregunta || "sin-item";
      const origen = item?.origen || "clase";
      return `${claseId}-${origen}-${itemId}`;
    },
    esActividadIa(item) {
      if (item?.es_creada_profesor === true) return false;
      if (item?.es_creada_profesor === false) return true;
      return String(item?.origen || "") === "ia";
    },
    actividadBloqueadaPorIa(item) {
      if (!this.esActividadIa(item)) return false;
      return this.normalizarBooleano(item?.entrega?.ia_correcta);
    },
    normalizarBooleano(valor) {
      if (valor === true || valor === 1) return true;
      if (typeof valor === "string") {
        const v = valor.trim().toLowerCase();
        return (
          v === "1" || v === "true" || v === "si" || v === "sí" || v === "yes"
        );
      }
      return false;
    },
    puedeEditarActividad(item) {
      if (item?.entrega?.corregido) return false;
      if (this.actividadBloqueadaPorIa(item)) return false;
      return true;
    },
    minimoCaracteresRespuesta(item) {
      return this.esActividadIa(item) ? 10 : 50;
    },
    obtenerRespuestaAlumno(item) {
      const key = this.claveRespuestaAlumno(item);
      return this.respuestasAlumnoPorActividad[key] || "";
    },
    contarCaracteresRespuesta(item) {
      const texto = this.obtenerRespuestaAlumno(item);
      return String(texto || "").trim().length;
    },
    actualizarRespuestaAlumno(item, value) {
      const key = this.claveRespuestaAlumno(item);
      this.$set(this.respuestasAlumnoPorActividad, key, String(value || ""));
      this.$set(this.mensajesActividadPorClave, key, "");
    },
    setMensajeActividad(item, mensaje, tipo = "info") {
      const key = this.claveRespuestaAlumno(item);
      this.$set(this.mensajesActividadPorClave, key, String(mensaje || ""));
      this.$set(this.mensajesActividadPorClave, `${key}__tipo`, tipo);
    },
    obtenerMensajeActividad(item) {
      const key = this.claveRespuestaAlumno(item);
      return this.mensajesActividadPorClave[key] || "";
    },
    colorMensajeActividad(item) {
      const key = this.claveRespuestaAlumno(item);
      const tipo = this.mensajesActividadPorClave[`${key}__tipo`] || "info";
      if (tipo === "error") return "error--text";
      if (tipo === "success") return "success--text";
      return "grey--text text--darken-1";
    },
    obtenerStorageRespuestasAlumnoKey() {
      const codCatedra =
        this.codCatedraReal || this.obtenerCodCatedra() || "sin-catedra";
      return `iea-respuestas-alumno-${codCatedra}`;
    },
    cargarRespuestasAlumnoGuardadas() {
      try {
        const key = this.obtenerStorageRespuestasAlumnoKey();
        const raw = window.localStorage.getItem(key);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        this.respuestasAlumnoPorActividad =
          parsed && typeof parsed === "object" ? parsed : {};
      } catch (error) {
        this.respuestasAlumnoPorActividad = {};
      }
    },
    guardarRespuestaAlumno(item) {
      const keyItem = this.claveRespuestaAlumno(item);
      const valorActual = (
        this.respuestasAlumnoPorActividad[keyItem] || ""
      ).trim();
      if (!valorActual) {
        return false;
      }
      const minChars = this.minimoCaracteresRespuesta(item);
      if (valorActual.length < minChars) {
        return false;
      }
      try {
        const key = this.obtenerStorageRespuestasAlumnoKey();
        window.localStorage.setItem(
          key,
          JSON.stringify(this.respuestasAlumnoPorActividad)
        );
        return true;
      } catch (error) {
        return false;
      }
    },
    onSeleccionarArchivoActividad(item, file) {
      const key = this.claveRespuestaAlumno(item);
      this.$set(this.archivosActividadPorItem, key, file || null);
    },
    async enviarRespuestaActividad(item) {
      if (!this.puedeEditarActividad(item)) {
        this.setMensajeActividad(
          item,
          "Esta actividad ya no puede editarse.",
          "error"
        );
        return;
      }
      const keyItem = this.claveRespuestaAlumno(item);
      const valorActual = (
        this.respuestasAlumnoPorActividad[keyItem] || ""
      ).trim();
      if (!valorActual) {
        this.setMensajeActividad(
          item,
          "Escribe una respuesta antes de guardar.",
          "error"
        );
        return;
      }
      const minChars = this.minimoCaracteresRespuesta(item);
      if (valorActual.length < minChars) {
        this.setMensajeActividad(
          item,
          `La respuesta debe tener al menos ${minChars} caracteres.`,
          "error"
        );
        return;
      }
      if (this.esActividadIa(item)) {
        await this.enviarRespuestaActividadIa(item, valorActual);
        return;
      }
      try {
        const entrega = await this.$API.post({
          url: "materia-codigo-clase/entregas",
          data: {
            pregunta_catedra_id: item.id,
            respuesta_texto: valorActual
          }
        });
        this.$set(
          item,
          "entrega",
          entrega && entrega.id ? entrega : entrega?.data || null
        );
        this.guardarRespuestaAlumno(item);
        this.setMensajeActividad(
          item,
          "Respuesta enviada correctamente.",
          "success"
        );
      } catch (error) {
        this.setMensajeActividad(
          item,
          this.obtenerMensajeErrorApi(error, "No se pudo enviar la respuesta."),
          "error"
        );
      }
    },
    async enviarRespuestaActividadIa(item, valorActual) {
      if (!this.claseSeleccionada?.id) {
        this.setMensajeActividad(item, "No hay clase seleccionada.", "error");
        return;
      }
      const actividadHash =
        item?.actividad_hash || this.generarHashActividadIa(item);
      try {
        const res = await this.$API.post({
          url: "ia/actividad/evaluar",
          data: {
            cod_catedra: this.obtenerCodCatedra(),
            materia_codigo_clase_id: this.claseSeleccionada.id,
            actividad_hash: actividadHash,
            actividad_pregunta: this.limpiarHtmlTexto(item?.pregunta || ""),
            actividad_consigna: this.limpiarHtmlTexto(item?.respuesta || ""),
            respuesta_alumno: valorActual
          }
        });
        const payload = res && res.entrega ? res : res?.data || {};
        const esCorrectaNormalizada = this.normalizarBooleano(
          payload?.es_correcta
        );
        const entrega = payload?.entrega || {
          respuesta_texto: valorActual,
          ia_correcta: esCorrectaNormalizada,
          ia_devolucion: payload?.devolucion || "",
          ia_consejo: payload?.consejo || "",
          status: esCorrectaNormalizada ? "ia_correcta" : "ia_incorrecta"
        };
        if (entrega) {
          this.$set(this.respuestasIaBackendPorHash, actividadHash, entrega);
          this.$set(item, "entrega", entrega);
        }
        this.guardarRespuestaAlumno(item);
        const estado = esCorrectaNormalizada ? "correcta" : "incorrecta";
        this.setMensajeActividad(
          item,
          `Respuesta evaluada por IA: ${estado}.`,
          "success"
        );
      } catch (error) {
        this.setMensajeActividad(
          item,
          this.obtenerMensajeErrorApi(
            error,
            "No se pudo validar la respuesta con IA."
          ),
          "error"
        );
      }
    },
    async enviarPdfActividad(item) {
      if (item?.entrega?.corregido) {
        this.setMensajeActividad(
          item,
          "Esta actividad ya fue corregida y no puede editarse.",
          "error"
        );
        return;
      }
      const key = this.claveRespuestaAlumno(item);
      const archivo = this.archivosActividadPorItem[key];
      if (!archivo) {
        this.setMensajeActividad(
          item,
          "Selecciona un archivo PDF antes de enviar.",
          "error"
        );
        return;
      }
      const formData = new FormData();
      formData.append("pregunta_catedra_id", item.id);
      formData.append("archivo", archivo);
      try {
        const entrega = await this.$API.post({
          url: "materia-codigo-clase/entregas",
          data: formData
        });
        this.$set(
          item,
          "entrega",
          entrega && entrega.id ? entrega : entrega?.data || null
        );
        this.$set(this.archivosActividadPorItem, key, null);
        this.setMensajeActividad(item, "PDF enviado correctamente.", "success");
      } catch (error) {
        this.setMensajeActividad(
          item,
          this.obtenerMensajeErrorApi(error, "No se pudo enviar el PDF."),
          "error"
        );
      }
    },
    normalizarPreguntasRespuestas(actividadesRaw, origen = "clase") {
      if (!actividadesRaw) return [];

      let items = [];
      if (Array.isArray(actividadesRaw)) {
        items = actividadesRaw;
      } else if (typeof actividadesRaw === "string") {
        const raw = actividadesRaw.trim();
        if (!raw) return [];
        if (raw.startsWith("[")) {
          try {
            const parsed = JSON.parse(raw);
            items = Array.isArray(parsed) ? parsed : [parsed];
          } catch (error) {
            items = raw
              .split(/[\n;]+/)
              .map(s => s.trim())
              .filter(Boolean);
          }
        } else {
          items = raw
            .split(/[\n;]+/)
            .map(s => s.trim())
            .filter(Boolean);
        }
      } else {
        items = [actividadesRaw];
      }

      return items
        .map((item, index) => {
          if (typeof item === "object" && item !== null) {
            const pregunta =
              item.title ||
              item.titulo ||
              item.pregunta ||
              item.question ||
              item.text ||
              "";
            const respuesta =
              item.content || item.respuesta || item.answer || item.value || "";
            if (!pregunta && !respuesta) return null;
            const origenDetectado = origen === "ia" ? "ia" : "clase";
            const esCreadaProfesor = item.es_creada_profesor === true;
            return {
              id: item.id || index,
              pregunta: String(pregunta || `Pregunta ${index + 1}`),
              respuesta: String(respuesta || "Sin respuesta cargada."),
              tipo: String(item.tipo || "pregunta_respuesta"),
              // pregunta_catedras.tipo_mod: 1 = preguntas viejas de la clase,
              // 2 = importadas del scorm.json. Si el backend no lo manda
              // asumimos 1 (es el default de la columna).
              tipo_mod: item.tipo_mod != null ? Number(item.tipo_mod) : 1,
              origen: origenDetectado,
              es_creada_profesor: esCreadaProfesor,
              actividad_hash:
                origenDetectado === "ia"
                  ? this.generarHashActividadIa({
                      pregunta: String(pregunta || ""),
                      respuesta: String(respuesta || ""),
                      index
                    })
                  : null,
              entrega: item.entrega || null
            };
          }

          const raw = String(item || "").trim();
          if (!raw) return null;
          const partes = raw
            .split("|")
            .map(p => p.trim())
            .filter(Boolean);
          const pregunta = partes[0] || `Pregunta ${index + 1}`;
          const respuesta =
            partes.slice(1).join(" | ") || "Sin respuesta cargada.";
          const origenDetectado = origen === "ia" ? "ia" : "clase";
          return {
            id: index,
            pregunta,
            respuesta,
            tipo: "pregunta_respuesta",
            tipo_mod: 1,
            origen: origenDetectado,
            es_creada_profesor: false,
            actividad_hash:
              origenDetectado === "ia"
                ? this.generarHashActividadIa({ pregunta, respuesta, index })
                : null,
            entrega: null
          };
        })
        .filter(Boolean);
    },
    generarHashActividadIa(item) {
      const claseId = String(this.claseSeleccionada?.id || "");
      const pregunta = this.limpiarHtmlTexto(item?.pregunta || "");
      const consigna = this.limpiarHtmlTexto(item?.respuesta || "");
      const base = `${claseId}::${pregunta}::${consigna}`.toLowerCase();
      let hash = 0;
      for (let i = 0; i < base.length; i += 1) {
        hash = (hash << 5) - hash + base.charCodeAt(i);
        hash |= 0;
      }
      return `ia-${claseId}-${Math.abs(hash)}`;
    },
    limpiarHtmlTexto(html) {
      return String(html || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    },
    obtenerMensajeErrorApi(error, fallback = "Ocurrió un error.") {
      const data = error?.response?.data || error?.data || null;
      if (typeof data === "string" && data.trim()) return data.trim();
      if (data?.message) return String(data.message);
      if (data?.error) return String(data.error);
      if (error?.message) return String(error.message);
      return fallback;
    },
    async cargarRespuestasIaClase(claseId) {
      if (!claseId) return;
      try {
        const res = await this.$API.get(
          {
            url: "ia/actividad/respuestas",
            data: { materia_codigo_clase_id: claseId }
          },
          false
        );
        this.respuestasIaBackendPorHash =
          res?.items && typeof res.items === "object" ? res.items : {};
      } catch (error) {
        this.respuestasIaBackendPorHash = {};
      }
    },
    obtenerActividadesClaseRaw(clase) {
      if (!clase) return null;
      const directas = [
        clase.actividades_clase,
        clase.actividad_clase,
        clase.actividadesClase,
        clase.actividades,
        clase.archivos_clase,
        clase.archivos,
        clase.pdf,
        clase.pdfs,
        clase.documentos
      ];
      const encontrada = directas.find(
        valor =>
          valor !== null && valor !== undefined && String(valor).trim() !== ""
      );
      if (encontrada !== undefined) return encontrada;

      if (Array.isArray(clase.materia_codigo_link)) {
        const nested = clase.materia_codigo_link
          .map(link => [
            link?.actividades_clase,
            link?.actividad_clase,
            link?.archivo,
            link?.pdf,
            link?.url_actividad
          ])
          .flat()
          .filter(Boolean);
        if (nested.length) return nested;
      }

      return null;
    },
    async cargarClasesMateria() {
      let codCatedra = this.obtenerCodCatedra();
      const materiaId = this.$route.params.materiaId;

      this.videosClaseBackendPorId = {};
      this.actividadesClaseBackendPorId = {};
      this.pdfClaseBackendPorId = {};
      this.codCatedraReal = "";
      this.materiaLinkPdf = "";
      this.bibliografia = "";
      this.pastilla = "";

      if (!codCatedra) {
        this.clasesError = "No se encontró el cod_catedra de la materia.";
        return;
      }

      this.clasesLoading = true;
      this.clasesError = "";

      try {
        // Consultamos si la materia tiene una optativa asignada para este alumno
        try {
          const optativaRes = await this.$API.get(
            {
              url: `materia/optativa/${materiaId}`
            },
            false
          );

          if (optativaRes && optativaRes.idPersonalizado) {
            codCatedra = optativaRes.idPersonalizado;
          }
        } catch (e) {
          // Si falla la consulta de optativa, continuamos con el codCatedra original
          console.warn("No se pudo obtener información de optativa:", e);
        }

        const res = await this.$API.get({
          url: `materia-codigo/show/${codCatedra}`,
          data: {}
        });

        const clasesRaw = Array.isArray(res?.materia_codigo_clase)
          ? res.materia_codigo_clase
          : [];
        const clasesVisibles = clasesRaw.filter(c => c.view != 0);

        this.codCatedraReal = String(res?.cod || codCatedra || "");
        
        // Recargar información del foro con el código real
        this.cargarCategoriasForoMateria();
        this.cargarForosMateria();

        this.cursoGoogleDriveUrl = res?.url_google_drive || "";
        this.materiaLinkPdf = res?.link_pdf || "";
        this.bibliografia = res?.bibliografia || "";
        this.pastilla = res?.pastilla || "";
        this.linkMeetMateria = res?.link_meet || "";
        this.codClassRoomMateria = res?.codClassRoom || "";
        this.nombreMateria = res?.nombre || "";

        let clasesBase = clasesVisibles.map((clase, index) => ({
          ...clase,
          materia_codigo_link: this.normalizarVideos(clase.materia_codigo_link),
          nombre: `Clase ${index + 1}`,
          numClaseReal: index + 1
        }));

        // Inyectar resumenes
        const resumenes = Array.isArray(res?.resumen_catedra)
          ? res.resumen_catedra
          : [];

        // Ordenamos para insertar de forma ascendente
        const sortedResumenes = [...resumenes].sort((a, b) => {
          const capA = String(a.capitulos || "").split(",");
          const capB = String(b.capitulos || "").split(",");
          return (
            parseInt(capA[capA.length - 1]) - parseInt(capB[capB.length - 1])
          );
        });

        sortedResumenes.forEach(resumen => {
          const caps = String(resumen.capitulos || "").split(",");
          const lastCapStr = caps[caps.length - 1];
          if (lastCapStr) {
            const ultimoCapNum = parseInt(lastCapStr.trim());
            if (!isNaN(ultimoCapNum)) {
              // Buscamos la clase (visible) que tenga el numClaseReal correspondiente
              const indexToInsert = clasesBase.findIndex(
                c => !c.isResumen && Number(c.numClaseReal) === ultimoCapNum
              );
              if (indexToInsert !== -1) {
                clasesBase.splice(indexToInsert + 1, 0, {
                  isResumen: true,
                  nombre: `Resumen capítulo ${resumen.capitulos}`,
                  path: resumen.path
                });
              }
            }
          }
        });

        this.clasesMateria = clasesBase;
        this.sincronizarActividadClaseSeleccionada();

        const claseGuardada = Number(res?.clase);
        const videoGuardado = Number(res?.video);
        const claseValida = Number.isFinite(claseGuardada)
          ? Math.max(0, Math.min(claseGuardada, this.clasesMateria.length - 1))
          : 0;
        const videosClase =
          this.clasesMateria[claseValida]?.materia_codigo_link || [];
        const videoValido = Number.isFinite(videoGuardado)
          ? Math.max(
              0,
              Math.min(videoGuardado, Math.max(0, videosClase.length - 1))
            )
          : 0;

        // Apagar el loading ANTES de seleccionar: seleccionarClase() arranca con
        // `if (this.clasesLoading) return`, y el finally recien lo apaga despues
        // de esta llamada. Por eso el video de la primera clase nunca se cargaba
        // solo y quedaba el placeholder hasta que el alumno clickeaba una clase.
        // Las clases ya estan en memoria en este punto.
        this.clasesLoading = false;

        if (this.clasesMateria.length) {
          await this.seleccionarClase(claseValida, videoValido);
        } else {
          this.currentVideoId = null;
          this.currentVideoUrl = null;
        }
      } catch (error) {
        console.error("cargarClasesMateria:", error);
        this.clasesError = "No se pudieron cargar las clases de la materia.";
        this.clasesMateria = [];
        this.cursoGoogleDriveUrl = "";
        this.materiaLinkPdf = "";
        this.bibliografia = "";
        this.pastilla = "";
        this.actividadClaseSeleccionada = null;
        this.currentVideoId = null;
        this.currentVideoUrl = null;
      } finally {
        this.clasesLoading = false;
      }
    },
    async abrirDetalleClase() {
      if (!this.claseSeleccionada?.id) {
        this.claseDetalleHtml = "";
        this.claseDetalleError = "No hay una clase seleccionada.";
        this.showClaseDetalleDialog = true;
        return;
      }

      this.showClaseDetalleDialog = true;
      this.claseDetalleLoading = true;
      this.claseDetalleError = "";

      try {
        const res = await this.$API.get({
          url: `materia-codigo-clase/content/${this.claseSeleccionada.id}`,
          data: {}
        });

        this.claseDetalleHtml = this.normalizarClaseDetalleHtml(
          res?.clase || ""
        );
      } catch (error) {
        this.claseDetalleHtml = "";
        this.claseDetalleError = "No se pudo cargar el detalle de la clase.";
      } finally {
        this.claseDetalleLoading = false;
      }
    },
    normalizarClaseDetalleHtml(html) {
      if (typeof html !== "string") return "";

      const htmlLimpio = html
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
        .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
        .replace(/<link[^>]*rel=["']?stylesheet["']?[^>]*>/gi, "")
        .trim();

      if (!htmlLimpio) return "";

      try {
        if (typeof DOMParser === "undefined") {
          return htmlLimpio
            .replace(/\sstyle=(['"]).*?\1/gi, "")
            .replace(/\sclass=(['"]).*?\1/gi, "")
            .replace(/\sid=(['"]).*?\1/gi, "")
            .replace(
              /\s(bgcolor|color|face|size|width|height|align|valign|border|cellpadding|cellspacing)=(['"]).*?\2/gi,
              ""
            )
            .trim();
        }

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlLimpio, "text/html");
        if (!doc?.body) return htmlLimpio;

        // Quitamos cualquier hoja/etiqueta de estilo que venga desde backend.
        doc
          .querySelectorAll("script, style, link[rel='stylesheet']")
          .forEach(node => node.remove());

        // Eliminamos todos los atributos que puedan arrastrar estilos antiguos.
        doc.body.querySelectorAll("*").forEach(node => {
          node.removeAttribute("style");
          node.removeAttribute("class");
          node.removeAttribute("id");
          node.removeAttribute("bgcolor");
          node.removeAttribute("color");
          node.removeAttribute("face");
          node.removeAttribute("size");
          node.removeAttribute("width");
          node.removeAttribute("height");
          node.removeAttribute("align");
          node.removeAttribute("valign");
          node.removeAttribute("border");
          node.removeAttribute("cellpadding");
          node.removeAttribute("cellspacing");
        });

        return (doc.body.innerHTML || "").trim();
      } catch (e) {
        return htmlLimpio;
      }
    },
    obtenerCodCatedra() {
      return this.$route.query.codCatedra || this.$route.params.materiaId;
    },
    normalizarVideos(videos) {
      if (!Array.isArray(videos)) return [];
      return videos.map(video => {
        const log = Array.isArray(video.materia_codigo_log)
          ? video.materia_codigo_log[0]
          : null;
        const segundoGuardadoRaw = Number(
          video.videoActualSegundo ||
            (log &&
              (log.videoActualSegundo ||
                log.video_transcurrido ||
                log.videoTranscurrido)) ||
            0
        );
        const segundoGuardado = Number.isFinite(segundoGuardadoRaw)
          ? Math.max(0, segundoGuardadoRaw)
          : 0;
        const porcentajeRaw = Number(video.porcentaje || 0);
        const porcentaje = Number.isFinite(porcentajeRaw)
          ? Math.min(100, Math.max(0, Math.round(porcentajeRaw)))
          : 0;

        return {
          ...video,
          videoActualSegundo: segundoGuardado,
          porcentaje
        };
      });
    },
    videoFinalizado(video) {
      const porcentaje = Number(video?.porcentaje || 0);
      return Boolean(video?.finalizado) || porcentaje >= 100;
    },
    claseFinalizada(clase) {
      const videos = Array.isArray(clase?.materia_codigo_link)
        ? clase.materia_codigo_link
        : [];
      if (!videos.length) return true;
      return videos.every(video => this.videoFinalizado(video));
    },
    claseFinalizadaParaProgreso(clase) {
      const videos = Array.isArray(clase?.materia_codigo_link)
        ? clase.materia_codigo_link
        : [];
      if (!videos.length) return false;
      return videos.every(video => this.videoFinalizado(video));
    },
    ubicarAlumnoEnClasePendiente() {
      if (!this.clasesMateria.length) {
        this.currentVideoId = null;
        this.currentVideoUrl = null;
        return;
      }

      let claseObjetivo = this.clasesMateria.findIndex(
        clase => !this.claseFinalizada(clase)
      );
      if (claseObjetivo < 0) {
        claseObjetivo = this.clasesMateria.length - 1;
      }

      const videos =
        this.clasesMateria[claseObjetivo]?.materia_codigo_link || [];
      let videoObjetivo = videos.findIndex(
        video => !this.videoFinalizado(video)
      );
      if (videoObjetivo < 0) {
        videoObjetivo = videos.length ? videos.length - 1 : 0;
      }

      this.seleccionarClase(claseObjetivo, videoObjetivo);
    },
    async seleccionarClase(index, videoIndex = 0, autoPlay = true) {
      if (this.clasesLoading) return;

      const clase = this.clasesMateria[index];
      if (!clase) return;

      if (clase.isResumen) {
        if (clase.path) {
          abrirArchivo(this.$API, clase.path);
        }
        return;
      }

      const seqCambio = ++this.cambioClaseSeq;

      try {
        const videosClase = Array.isArray(
          this.clasesMateria[index]?.materia_codigo_link
        )
          ? this.clasesMateria[index].materia_codigo_link
          : [];
        const videoIndexNormalizado = videosClase.length
          ? Math.max(0, Math.min(videoIndex, videosClase.length - 1))
          : 0;

        const cambiaContenido =
          this.selectedClaseIndex !== index ||
          this.selectedVideoIndex !== videoIndexNormalizado;
        if (cambiaContenido) {
          this.guardarProgresoVideo("paused");
        }

        this.selectedClaseIndex = index;
        this.selectedVideoIndex = videoIndexNormalizado;
        this.autoPlayCurrentVideo = autoPlay;
        this.sincronizarActividadClaseSeleccionada();

        // 1) render inmediato con datos en memoria
        this.cargarVideoSeleccionado();

        // 2) sincroniza data fresca de clase y vuelve a pintar
        const claseActual = this.clasesMateria[index];
        await Promise.allSettled([
          this.cargarVideosClaseDesdeBackend(claseActual),
          this.cargarActividadesClaseDesdeBackend(claseActual),
          this.cargarActividadesScorm(claseActual?.id)
        ]);

        if (seqCambio !== this.cambioClaseSeq) return;
        this.refrescarPanelCentral();
      } catch (error) {
        this.refrescarPanelCentral();
      }
    },
    // El cambio de key recrea el panel entero, iframe de YouTube incluido: si el
    // video no cambio eso lo reiniciaba de cero apenas contestaba el backend.
    refrescarPanelCentral() {
      const videoAntes = this.currentVideoId || this.currentVideoUrl;
      this.cargarVideoSeleccionado();
      const videoDespues = this.currentVideoId || this.currentVideoUrl;
      if (videoAntes !== videoDespues) {
        this.panelCentralRenderKey += 1;
      }
    },
    async cargarVideosClaseDesdeBackend(clase) {
      const claseId = clase?.id;
      const codCatedra = this.codCatedraReal || this.obtenerCodCatedra();
      if (!claseId || !codCatedra) return;

      const requestSeq = ++this.videosClaseRequestSeq;

      try {
        const res = await this.$API.get(
          {
            url: "materia-codigo-clase/videos",
            data: {
              cod_catedra: codCatedra,
              materia_codigo_clase_id: claseId
            }
          },
          false
        );

        if (requestSeq !== this.videosClaseRequestSeq) return;

        const videos = this.normalizarVideos(
          Array.isArray(res?.videos) ? res.videos : []
        );
        this.$set(this.videosClaseBackendPorId, claseId, videos);

        const claseIndex = this.clasesMateria.findIndex(c => c?.id === claseId);
        if (claseIndex >= 0) {
          const videosActuales = Array.isArray(
            this.clasesMateria[claseIndex]?.materia_codigo_link
          )
            ? this.clasesMateria[claseIndex].materia_codigo_link
            : [];
          const videosFinales = videos.length ? videos : videosActuales;
          this.$set(
            this.clasesMateria[claseIndex],
            "materia_codigo_link",
            videosFinales
          );
          if (this.selectedClaseIndex === claseIndex) {
            const nextIndex = videosFinales.length
              ? Math.max(
                  0,
                  Math.min(this.selectedVideoIndex, videosFinales.length - 1)
                )
              : 0;
            const cambioVideo = nextIndex !== this.selectedVideoIndex;
            this.selectedVideoIndex = nextIndex;
            if (cambioVideo || !this.currentVideoId) {
              this.cargarVideoSeleccionado();
            }
          }
        }
      } catch (error) {
        // Conservamos el estado actual para no vaciar videos si falla la API.
      }
    },
    async cargarActividadesClaseDesdeBackend(clase) {
      const claseId = clase?.id;
      const codCatedra = this.codCatedraReal || this.obtenerCodCatedra();
      const turnoCurso = this.obtenerTurnoCurso();

      if (!claseId || !codCatedra) return;
      const requestSeq = ++this.actividadesClaseRequestSeq;

      try {
        let res = await this.$API.get(
          {
            url: "materia-codigo-clase/actividades",
            data: {
              cod_catedra: codCatedra,
              materia_codigo_clase_id: claseId,
              turno: turnoCurso
            }
          },
          false
        );

        // Fallback: si por turno no trae datos, reintenta sin turno.
        if (!Array.isArray(res?.actividades) || !res.actividades.length) {
          res = await this.$API.get(
            {
              url: "materia-codigo-clase/actividades",
              data: {
                cod_catedra: codCatedra,
                materia_codigo_clase_id: claseId
              }
            },
            false
          );
        }

        if (requestSeq !== this.actividadesClaseRequestSeq) return;

        const actividades = Array.isArray(res?.actividades) ? res.actividades : [];
        const materiales = Array.isArray(res?.materiales) ? res.materiales : [];
        
        this.$set(this.actividadesClaseBackendPorId, claseId, actividades);
        this.$set(this.materialesClaseBackendPorId, claseId, materiales);
        const linkPdfClase = this.normalizarValorPdf(res?.link_pdf);
        this.$set(this.pdfClaseBackendPorId, claseId, linkPdfClase);
        await this.cargarRespuestasIaClase(claseId);
      } catch (error) {
        // Conservamos actividades previas en caso de error temporal.
        await this.cargarRespuestasIaClase(claseId);
      } finally {
        this.sincronizarActividadClaseSeleccionada();
      }
    },
    async seleccionarVideo(index, autoPlay = true) {
      if (!this.videosClaseSeleccionada[index]) return;
      const cambiaContenido = this.selectedVideoIndex !== index;
      if (cambiaContenido) {
        this.guardarProgresoVideo("paused");
      }
      this.selectedVideoIndex = index;
      this.autoPlayCurrentVideo = autoPlay;
      this.cargarVideoSeleccionado();
    },
    obtenerAnteriorDisponible() {
      if (!this.clasesMateria.length) return null;

      const videosActuales = this.videosClaseSeleccionada;
      if (videosActuales.length && this.selectedVideoIndex > 0) {
        return {
          claseIndex: this.selectedClaseIndex,
          videoIndex: this.selectedVideoIndex - 1
        };
      }

      for (
        let claseIndex = this.selectedClaseIndex - 1;
        claseIndex >= 0;
        claseIndex -= 1
      ) {
        const videos = Array.isArray(
          this.clasesMateria[claseIndex]?.materia_codigo_link
        )
          ? this.clasesMateria[claseIndex].materia_codigo_link
          : [];
        if (videos.length) {
          return {
            claseIndex,
            videoIndex: videos.length - 1
          };
        }
      }

      return null;
    },
    obtenerSiguienteDisponible() {
      if (!this.clasesMateria.length) return null;

      const videosActuales = this.videosClaseSeleccionada;
      if (
        videosActuales.length &&
        this.selectedVideoIndex < videosActuales.length - 1
      ) {
        return {
          claseIndex: this.selectedClaseIndex,
          videoIndex: this.selectedVideoIndex + 1
        };
      }

      for (
        let claseIndex = this.selectedClaseIndex + 1;
        claseIndex < this.clasesMateria.length;
        claseIndex += 1
      ) {
        const videos = Array.isArray(
          this.clasesMateria[claseIndex]?.materia_codigo_link
        )
          ? this.clasesMateria[claseIndex].materia_codigo_link
          : [];
        if (videos.length) {
          return {
            claseIndex,
            videoIndex: 0
          };
        }
      }

      return null;
    },
    async irAnteriorContenido(autoPlay = true) {
      const destino = this.obtenerAnteriorDisponible();
      if (!destino) return;
      this.seleccionarClase(destino.claseIndex, destino.videoIndex, autoPlay);
    },
    async irSiguienteContenido(autoPlay = true) {
      const destino = this.obtenerSiguienteDisponible();
      if (!destino) return;
      this.seleccionarClase(destino.claseIndex, destino.videoIndex, autoPlay);
    },
    async onVideoReady() {
      this.aplicarInicioVideoActual();
    },
    onVideoPlaying() {
      this.iniciarMonitoreoProgreso();
      this.enviarEstadoVideo("playing");
    },
    onVideoPaused() {
      this.detenerMonitoreoProgreso();
      this.enviarEstadoVideo("paused");
    },
    async onVideoEnded() {
      this.detenerMonitoreoProgreso();
      const videoActual = this.videosClaseSeleccionada[this.selectedVideoIndex];
      if (videoActual) {
        videoActual.porcentaje = 100;
        videoActual.finalizado = true;
      }
      await this.guardarProgresoVideo("ended");
      this.irSiguienteContenido(false);
    },
    iniciarMonitoreoProgreso() {
      this.detenerMonitoreoProgreso();
      this.progressInterval = setInterval(async () => {
        const porcentaje = await this.obtenerPorcentajeActualVideo();
        const videoActual = this.videosClaseSeleccionada[
          this.selectedVideoIndex
        ];
        if (!videoActual) return;
        videoActual.porcentaje = porcentaje;
        if (porcentaje >= 100) {
          videoActual.finalizado = true;
        }
      }, 1000);
    },
    detenerMonitoreoProgreso() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
        this.progressInterval = null;
      }
    },
    getPlayer() {
      if (this.currentVideoUrl) {
        return this.getPlayerHtml();
      }
      return this.$refs.youtube && this.$refs.youtube.player
        ? this.$refs.youtube.player
        : null;
    },
    obtenerStartSecondsVideo(videoActual) {
      if (!videoActual) return 0;
      if (this.videoFinalizado(videoActual)) return 0;
      const saved = Number(
        videoActual.videoActualSegundo ||
          videoActual.video_transcurrido ||
          videoActual.videoTranscurrido ||
          this.pendingStartSeconds ||
          0
      );
      return Number.isFinite(saved) ? Math.max(0, saved) : 0;
    },
    async sincronizarPlayerConVideoActual() {
      try {
        const player = this.getPlayer();
        const videoActual = this.videosClaseSeleccionada[
          this.selectedVideoIndex
        ];
        const videoId = this.currentVideoId;
        if (!player || !videoActual || !videoId) return false;

        const startSeconds = this.obtenerStartSecondsVideo(videoActual);

        if (this.autoPlayCurrentVideo) {
          player.loadVideoById({
            videoId,
            startSeconds
          });
        } else {
          player.cueVideoById({
            videoId,
            startSeconds
          });
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    async obtenerPorcentajeActualVideo() {
      const player = this.getPlayer();
      if (!player) return 0;
      const transcurrido = Number(await player.getCurrentTime());
      const duracion = Number(await player.getDuration());
      if (!duracion) return 0;
      const porcentaje = Math.round((transcurrido / duracion) * 100);
      return Math.min(100, Math.max(0, porcentaje));
    },
    async guardarProgresoVideo(tipo) {
      try {
        const videoActual = this.videosClaseSeleccionada[
          this.selectedVideoIndex
        ];
        if (!videoActual || !videoActual.id) return;

        const player = this.getPlayer();
        const videoTranscurrido = player
          ? Number(await player.getCurrentTime())
          : 0;
        const videoDuracion = player ? Number(await player.getDuration()) : 0;
        const porcentaje = videoDuracion
          ? Math.min(
              100,
              Math.max(0, Math.round((videoTranscurrido / videoDuracion) * 100))
            )
          : Number(videoActual.porcentaje || 0);

        videoActual.porcentaje = porcentaje;

        await this.$API.post({
          url: "materiaCodigoEstadistica/store/statusVideo",
          data: {
            alumno_id: parseInt(this.user.IDStB || 0),
            materiaCodigoClase_id:
              videoActual.materiaCodigoClase_id || this.claseSeleccionada?.id,
            materiaCodigoLink_id: videoActual.id,
            posicionClase: this.selectedClaseIndex,
            posicionVideo: this.selectedVideoIndex,
            videoTranscurrido,
            videoDuracion,
            videoPorcentaje: porcentaje,
            tipo,
            docente: this.esDocente
          }
        });
      } catch (error) {
        // Evitamos romper la reproducción si falla el guardado.
      }
    },
    async enviarEstadoVideo(tipo) {
      try {
        const videoActual = this.videosClaseSeleccionada[
          this.selectedVideoIndex
        ];
        if (!videoActual || !videoActual.id) return;

        const player = this.getPlayer();
        const videoTranscurrido = player
          ? Number(await player.getCurrentTime())
          : Number(videoActual.videoActualSegundo || 0);
        const videoDuracion = player
          ? Number(await player.getDuration())
          : Number(videoActual.videoDuracion || 0);
        const videoPorcentaje = videoDuracion
          ? Math.min(
              100,
              Math.max(0, Math.round((videoTranscurrido / videoDuracion) * 100))
            )
          : Number(videoActual.porcentaje || 0);

        videoActual.videoActualSegundo = videoTranscurrido;
        videoActual.videoDuracion = videoDuracion;
        videoActual.porcentaje = videoPorcentaje;

        await this.$API.post({
          url: "materiaCodigoEstadistica/store/statusVideo",
          data: {
            alumno_id: parseInt(this.user.IDStB || 0),
            materiaCodigoClase_id:
              videoActual.materiaCodigoClase_id || this.claseSeleccionada?.id,
            materiaCodigoLink_id: videoActual.id,
            posicionClase: this.selectedClaseIndex,
            posicionVideo: this.selectedVideoIndex,
            videoTranscurrido,
            videoDuracion,
            videoPorcentaje,
            tipo,
            docente: this.esDocente
          }
        });
      } catch (error) {
        // no-op
      }
    },
    cargarVideoSeleccionado() {
      let video = this.videosClaseSeleccionada[this.selectedVideoIndex];
      let nextVideoId = this.obtenerVideoId(video?.link);
      let nextVideoUrl = this.obtenerVideoUrlDirecta(video?.link);

      if ((!video || (!nextVideoId && !nextVideoUrl)) && this.videosClaseSeleccionada.length) {
        const idxValido = this.videosClaseSeleccionada.findIndex(
          v =>
            Boolean(this.obtenerVideoId(v?.link)) ||
            Boolean(this.obtenerVideoUrlDirecta(v?.link))
        );
        if (idxValido >= 0) {
          this.selectedVideoIndex = idxValido;
          video = this.videosClaseSeleccionada[idxValido];
          nextVideoId = this.obtenerVideoId(video?.link);
          nextVideoUrl = this.obtenerVideoUrlDirecta(video?.link);
        }
      }

      // Ya esta cargado este mismo video: no se toca nada. seleccionarClase()
      // vuelve a llamar aca cuando contesta el backend, y reposicionar el
      // player en el segundo guardado reiniciaba el video a los pocos segundos
      // de arrancar (y disparaba otro statusVideo).
      const yaCargado =
        (nextVideoId && nextVideoId === this.currentVideoId) ||
        (nextVideoUrl && !nextVideoId && nextVideoUrl === this.currentVideoUrl);
      if (yaCargado) return;

      this.detenerMonitoreoProgreso();

      if (!video || !video.link) {
        this.currentVideoId = null;
        this.currentVideoUrl = null;
        this.pendingStartSeconds = 0;
        return;
      }
      // Video ya terminado: arranca de cero. Si no, se retomaba en el ultimo
      // segundo guardado (el final), el player disparaba "ended" de una y
      // saltaba solo a la clase siguiente / no dejaba dar play de nuevo.
      // Se limpia antes para no arrastrar el segundo del video anterior
      // (obtenerStartSecondsVideo lo usa como ultimo fallback).
      this.pendingStartSeconds = 0;
      this.pendingStartSeconds = this.obtenerStartSecondsVideo(video);
      if (!nextVideoId && !nextVideoUrl) {
        this.currentVideoId = null;
        this.currentVideoUrl = null;
        return;
      }
      this.currentVideoId = nextVideoId;
      this.currentVideoUrl = nextVideoId ? null : nextVideoUrl;
      this.$nextTick(() => {
        this.aplicarInicioVideoActual();
      });
    },

    /**
     * Devuelve la URL cuando el link NO es de YouTube (video subido al sistema
     * de contenido, hoy DigitalOcean Spaces). Se apoya en obtenerVideoId para no
     * duplicar la regla: si eso resuelve un id, es de YouTube y no es directa.
     */
    obtenerVideoUrlDirecta(link) {
      const raw = String(link || "").trim();
      if (!raw || !/^https?:\/\//i.test(raw)) return null;
      return this.obtenerVideoId(raw) ? null : raw;
    },

    /**
     * Adaptador del <video> nativo a la interfaz del player de YouTube, para
     * que el tracking de progreso (getCurrentTime/getDuration/seekTo) siga
     * funcionando sin ramificar toda la logica de logs.
     */
    getPlayerHtml() {
      const el = this.$refs.videoHtml;
      if (!el) return null;
      return {
        getCurrentTime: () => Number(el.currentTime || 0),
        getDuration: () => Number(el.duration || 0),
        seekTo: seconds => {
          el.currentTime = Number(seconds) || 0;
        },
        // El navegador bloquea play() sin gesto previo del usuario y devuelve una
        // promesa rechazada. Sin el catch queda un unhandled rejection en consola;
        // el video igual se ve con sus controles para que el alumno le de play.
        playVideo: () => {
          const p = el.play();
          if (p && typeof p.catch === "function") p.catch(() => {});
        },
        pauseVideo: () => el.pause()
      };
    },
    aplicarInicioVideoActual() {
      try {
        const player = this.getPlayer();
        if (!player) return;

        const startSeconds = Number(this.pendingStartSeconds || 0);
        if (startSeconds > 0 && player.seekTo) {
          player.seekTo(startSeconds, true);
        }

        if (this.autoPlayCurrentVideo && player.playVideo) {
          player.playVideo();
        }
      } catch (error) {
        // no-op
      }
    },
    obtenerVideoId(link) {
      if (!link) return null;
      const raw = String(link).trim();
      if (!raw) return null;
      if (!raw.includes("http")) {
        return /^[A-Za-z0-9_-]{11}$/.test(raw) ? raw : null;
      }

      try {
        const url = new URL(raw);
        const host = (url.hostname || "").toLowerCase();
        const path = url.pathname || "";

        if (host.includes("youtu.be")) {
          const id = path.replace(/^\/+/, "").split("/")[0];
          if (/^[A-Za-z0-9_-]{11}$/.test(id || "")) return id;
        }

        const v = url.searchParams.get("v");
        if (/^[A-Za-z0-9_-]{11}$/.test(v || "")) return v;

        const parts = path.split("/").filter(Boolean);
        const idxEmbed = parts.indexOf("embed");
        if (
          idxEmbed >= 0 &&
          /^[A-Za-z0-9_-]{11}$/.test(parts[idxEmbed + 1] || "")
        )
          return parts[idxEmbed + 1];

        const idxShorts = parts.indexOf("shorts");
        if (
          idxShorts >= 0 &&
          /^[A-Za-z0-9_-]{11}$/.test(parts[idxShorts + 1] || "")
        )
          return parts[idxShorts + 1];

        const idxLive = parts.indexOf("live");
        if (
          idxLive >= 0 &&
          /^[A-Za-z0-9_-]{11}$/.test(parts[idxLive + 1] || "")
        )
          return parts[idxLive + 1];
      } catch (e) {
        // fallback a regex debajo
      }

      const match = raw.match(
        /(?:v=|youtu\.be\/|embed\/|shorts\/|live\/)([A-Za-z0-9_-]{11})/i
      );
      return match && match[1] ? match[1] : null;
    },
    etapaProgresoVideo(porcentaje) {
      const p = Number(porcentaje || 0);
      if (p >= 100) return "100% completado";
      if (p >= 75) return "75% avanzado";
      if (p >= 50) return "50% avanzado";
      if (p >= 25) return "25% avanzado";
      return "Inicio";
    },
    colorProgresoVideo(porcentaje) {
      const p = Number(porcentaje || 0);
      if (p >= 100) return "success";
      if (p >= 75) return "light-green";
      if (p >= 50) return "amber darken-2";
      if (p >= 25) return "orange";
      return "red lighten-1";
    },
    normalizarActividadesClase(actividadesRaw) {
      if (!actividadesRaw) return [];

      const normalizarItem = (item, index) => {
        if (!item) return null;

        if (typeof item === "object") {
          const value =
            item.url ||
            item.link ||
            item.path ||
            item.value ||
            item.content ||
            item.archivo ||
            item.pdf ||
            item.file;
          if (!value) return null;
          const text =
            item.text ||
            item.nombre ||
            item.name ||
            item.titulo ||
            this.nombreArchivoDesdeUrl(value, index);
          return {
            text,
            value: this.resolverUrlActividad(value)
          };
        }

        const raw = String(item).trim();
        if (!raw) return null;

        if (raw.includes("|")) {
          const partes = raw
            .split("|")
            .map(p => p.trim())
            .filter(Boolean);
          const valor =
            partes.find(p => /^https?:\/\//i.test(p)) ||
            partes[partes.length - 1];
          const texto =
            partes.find(p => p !== valor) ||
            this.nombreArchivoDesdeUrl(valor, index);
          return {
            text: texto,
            value: this.resolverUrlActividad(valor)
          };
        }

        return {
          text: this.nombreArchivoDesdeUrl(raw, index),
          value: this.resolverUrlActividad(raw)
        };
      };

      let items = [];
      if (Array.isArray(actividadesRaw)) {
        items = actividadesRaw;
      } else if (typeof actividadesRaw === "string") {
        const raw = actividadesRaw.trim();
        if (!raw) return [];

        if (raw.startsWith("[")) {
          try {
            const parsed = JSON.parse(raw);
            items = Array.isArray(parsed) ? parsed : [parsed];
          } catch (error) {
            items = raw
              .replace(/<br\s*\/?>/gi, "\n")
              .split(/[\n,;]+/)
              .map(s => s.trim())
              .filter(Boolean);
          }
        } else {
          items = raw
            .replace(/<br\s*\/?>/gi, "\n")
            .split(/[\n,;]+/)
            .map(s => s.trim())
            .filter(Boolean);
        }
      } else {
        items = [actividadesRaw];
      }

      return items
        .map((item, index) => normalizarItem(item, index))
        .filter(item => item && item.value);
    },
    resolverUrlActividad(url) {
      const value = String(url || "").trim();
      if (!value) return "";
      if (/^https?:\/\//i.test(value)) return value;
      return `${this.$API.routeApi}${value.replace(/^\/+/, "")}`;
    },
    nombreArchivoDesdeUrl(url, index) {
      const value = String(url || "").trim();
      const sinQuery = value.split("?")[0];
      const partes = sinQuery.split("/").filter(Boolean);
      const ultimo = partes[partes.length - 1];
      if (ultimo) return decodeURIComponent(ultimo);
      return `Actividad ${index + 1}`;
    },
    sincronizarActividadClaseSeleccionada() {
      const actividades = this.actividadesClaseDisponibles;
      if (!actividades.length) {
        this.actividadClaseSeleccionada = null;
        return;
      }

      const existeSeleccion = actividades.some(
        a => a.value === this.actividadClaseSeleccionada
      );
      if (!existeSeleccion) {
        this.actividadClaseSeleccionada = actividades[0].value;
      }
    },
    descargarActividadClase() {
      const actividades = this.actividadesClaseDisponibles;
      if (!actividades.length) return;
      const url = this.actividadClaseSeleccionada || actividades[0].value;
      if (!url) return;
      window.open(url, "_blank");
    },
    descargarPdfClaseActual() {
      if (!this.pdfClaseActualUrl) return;
      abrirArchivo(this.$API, this.pdfClaseActualUrl);
    },
    descargarPdfCurso() {
      if (!this.pdfCursoUrl) return;
      abrirArchivo(this.$API, this.pdfCursoUrl);
    },
    abrirRecursoCurso() {
      if (!this.cursoGoogleDriveUrl) return;
      window.open(this.cursoGoogleDriveUrl, "_blank");
    },
    generarActividadesRandom() {
      // Actividades Legado (Originales)
      const actividadesLegado = [
        {
          titulo: "Definiciones de Redes",
          descripcion: "Relaciona cada concepto con su definición correcta.",
          tipo: "arrastrar",
          disponibles: ["Router", "Switch", "IP", "DNS"],
          items: [
            { definicion: "Dispositivo que conecta diferentes redes.", correcta: "Router" },
            { definicion: "Identificador único para cada dispositivo.", correcta: "IP" }
          ],
          respuestas: [null, null],
          resultado: null
        }
      ];
      this.actividades = actividadesLegado;
    },
    // Las interactivas salen de pregunta_catedras con tipo_mod = 2 (importadas
    // del scorm.json de la catedra). El backend ya baraja las opciones y no
    // manda las correctas ni el feedback: eso llega recien al verificar.
    async cargarActividadesScorm(claseId) {
      if (!claseId) {
        this.actividadesInteractivas = [];
        return;
      }

      const seq = ++this.actividadesScormSeq;

      try {
        const res = await this.$API.get(
          { url: `actividades-scorm/clase/${claseId}`, data: {} },
          false
        );

        if (seq !== this.actividadesScormSeq) return;

        const actividades = Array.isArray(res) ? res : [];
        this.shuffledOptionsMap = {};
        actividades.forEach(actividad => this.inicializarRespuesta(actividad));
        this.actividadesInteractivas = actividades;
        this.triggerMathJax();
      } catch (error) {
        if (seq !== this.actividadesScormSeq) return;
        this.actividadesInteractivas = [];
      }
    },
    inicializarRespuesta(actividad) {
      let inicial = null;
      if (actividad.type === "MULTIPLE_CHOICE") {
        inicial = [];
      } else if (actividad.type === "FILL_IN_THE_BLANK") {
        inicial = new Array(actividad.blank_count || 0).fill("");
      }
      this.$set(this.respuestasActividades, actividad.id, inicial);
    },
    onDragStart(item) {
      this.dragItem = item;
    },
    onDrop(actividad, index) {
      if (!this.dragItem) return;
      if (actividad.respuestas[index]) {
        actividad.disponibles.push(actividad.respuestas[index]);
      }
      actividad.respuestas.splice(index, 1, this.dragItem);
      actividad.disponibles = actividad.disponibles.filter(
        d => d !== this.dragItem
      );
      this.dragItem = null;
    },
    quitarRespuesta(actividad, index) {
      const actual = actividad.respuestas[index];
      if (!actual) return;
      actividad.disponibles.push(actual);
      actividad.respuestas.splice(index, 1, null);
    },
    verificarArrastrar(actividad) {
      const total = actividad.items.length;
      let correctas = 0;
      actividad.items.forEach((item, i) => {
        if (actividad.respuestas[i] === item.termino) correctas += 1;
      });
      actividad.resultado = `Resultado: ${correctas}/${total} correctas`;
    },
    reiniciarArrastrar(actividad) {
      actividad.respuestas = actividad.items.map(() => null);
      actividad.disponibles = actividad.items
        .map(i => i.termino)
        .sort(() => Math.random() - 0.5);
      actividad.resultado = "";
    },
    verificarCuestionario(actividad) {
      if (!actividad.respuestaSeleccionada) {
        actividad.resultado = "Selecciona una opción.";
        return;
      }
      actividad.resultado = "Respuesta enviada (demo).";
    },
    verificarCodigo(actividad) {
      if (!actividad.respuestaCodigo) {
        actividad.resultado = "Completa la línea faltante.";
        return;
      }
      actividad.resultado = "Código verificado (demo).";
    },
    async preguntarIA() {
      const pregunta = (this.iaQuestion || "").trim();
      if (!pregunta) {
        this.iaError = "Escribe una pregunta para continuar.";
        return;
      }

      this.iaLoading = true;
      this.iaError = "";

      try {
        const res = await this.$API.post({
          url: "ia/gemini/ask",
          data: {
            message: pregunta,
            cod_catedra: this.obtenerCodCatedra(),
            materia_codigo_clase_id: this.claseSeleccionada
              ? this.claseSeleccionada.id
              : null,
            history: this.iaHistory
          }
        });

        this.iaLastQuestion = pregunta;
        this.iaReply = res.reply || "No hubo respuesta.";
        this.iaModel = res.model || "";
        this.iaApiVersion = res.api_version || "";
        this.iaHistory = Array.isArray(res.conversation)
          ? res.conversation
          : this.iaHistory;
        this.iaQuestion = "";
      } catch (error) {
        this.iaError = "No se pudo consultar Gemini. Intenta nuevamente.";
      } finally {
        this.iaLoading = false;
      }
    },
    getAutorForo(item) {
      if (!item) return "Usuario CETAE";
      if (item.alumno) {
        return `${item.alumno.Nombres || ""} ${item.alumno.Apellidos || ""}`.trim();
      }
      if (item.profesor) return item.profesor.usu_nombre || "Docente";
      if (item.docente) return item.docente.usu_nombre || "Docente";
      if (item.usuario) return item.usuario.usu_nombre || "Docente";
      return "Usuario CETAE";
    },
    getFechaRelativa(fecha) {
      if (!fecha) return "";
      return moment(fecha).fromNow();
    },
    async cargarCategoriasForoMateria() {
      // Usamos el código real si ya se cargó, de lo contrario el de la ruta
      const catedraId = this.codCatedraReal || this.obtenerCodCatedra();
      if (!catedraId) return;
      
      try {
        // Intentamos con varios endpoints en orden de relevancia
        const endpoints = [
          `forum-categories-by-materia/${catedraId}`,
          `forum-categories-by-catedra/${catedraId}`
        ];

        let res = null;
        for (const url of endpoints) {
          res = await this.$API.get({ url, data: {} });
          if (Array.isArray(res) && res.length > 0) break;
        }
        
        // Fallback final: todas las categorías si no hay específicas
        if (!Array.isArray(res) || res.length === 0) {
          res = await this.$API.get({ url: "forum-categories", data: {} });
        }

        this.foroCategoriasMateria = Array.isArray(res) ? res : [];
        if (!this.foroForm.categoryId && this.foroCategoriasMateria.length) {
          this.foroForm.categoryId = this.foroCategoriasMateria[0].id;
        }
      } catch (error) {
        console.error("Error cargando categorías de foro:", error);
        this.foroCategoriasMateria = [];
      }
    },
    async cargarForosMateria() {
      const catedraId = this.codCatedraReal || this.obtenerCodCatedra();
      if (!catedraId) return;
      
      this.foroLoading = true;
      this.foroError = "";
      
      try {
        // Intentamos cargar foros desde ambos posibles endpoints
        const resMateria = await this.$API.get({
          url: `forums-by-materia/${catedraId}`,
          data: {}
        });
        
        const resCatedra = await this.$API.get({
          url: `forums-by-catedra/${catedraId}`,
          data: {}
        });

        // Combinamos resultados y eliminamos duplicados
        const itemsMateria = resMateria?.data || (Array.isArray(resMateria) ? resMateria : []);
        const itemsCatedra = resCatedra?.data || (Array.isArray(resCatedra) ? resCatedra : []);
        
        const combined = [...itemsMateria, ...itemsCatedra];
        const unique = combined.filter((v, i, a) => a.findIndex(t => t.id === v.id) === i);
        
        this.forosMateria = unique;
      } catch (error) {
        console.error("Error cargando foros:", error);
        this.foroError = "No se pudieron cargar los foros de esta materia.";
        this.forosMateria = [];
      } finally {
        this.foroLoading = false;
      }
    },
    abrirForoDetalle(foro) {
      this.foroSeleccionado = foro;
      this.foroComentario = "";
    },
    imagenesForo(foro) {
      return (foro?.images || []).filter(img => img.status == 1);
    },
    abrirDialogForoNuevo() {
      this.showForoForm = true;
    },
    async guardarForoNuevo() {
      if (
        !this.foroForm.title ||
        !this.foroForm.content ||
        !this.foroForm.categoryId
      ) {
        this.foroError = "Completa título, contenido y sección.";
        return;
      }
      const formData = new FormData();
      formData.append("title", this.foroForm.title);
      formData.append("content", this.foroForm.content);
      formData.append("forum_category_id", this.foroForm.categoryId);
      formData.append("type", "public");
      formData.append("catedra_id", this.obtenerCodCatedra());
      formData.append("cod", this.obtenerCodCatedra());
      // Mismo formato que Foro.vue: ForumController@store lee imagen_0..n.
      const imagenes = this.foroForm.imagenes || [];
      formData.append("cantidadImagen", imagenes.length);
      imagenes.forEach((file, i) => formData.append(`imagen_${i}`, file, file.name));
      try {
        const res = await this.$API.post({
          url: "forums",
          data: formData
        });
        this.showForoForm = false;
        this.foroForm.title = "";
        this.foroForm.content = "";
        this.foroForm.imagenes = [];
        if (res && res.id) {
          await this.cargarForosMateria();
          const found = this.forosMateria.find(f => f.id === res.id);
          this.foroSeleccionado = found || null;
        }
      } catch (error) {
        this.foroError = "No se pudo crear el tema.";
      }
    },
    async enviarComentarioForo() {
      if (!this.foroSeleccionado?.id || !this.foroComentario.trim()) return;
      const formData = new FormData();
      formData.append("comment", this.foroComentario.trim());
      formData.append("tagged", "");
      try {
        const comment = await this.$API.post({
          url: `forums-comment/${this.foroSeleccionado.id}`,
          data: formData
        });
        if (!Array.isArray(this.foroSeleccionado.comments)) {
          this.foroSeleccionado.comments = [];
        }
        this.foroSeleccionado.comments.unshift(comment);
        this.foroComentario = "";
      } catch (error) {
        this.foroError = "No se pudo enviar el comentario.";
      }
    },
    async likeForo(foro) {
      if (!foro?.id) return;
      const ok = await this.$API.post({
        url: `forums-like/${foro.id}`,
        data: {}
      });
      if (ok) foro.likes = Number(foro.likes || 0) + 1;
    },
    async dislikeForo(foro) {
      if (!foro?.id) return;
      const ok = await this.$API.delete({
        url: `forums-like/${foro.id}`,
        data: {}
      });
      if (ok) foro.likes = Math.max(0, Number(foro.likes || 0) - 1);
    },
    linkMeet(code) {
      return "https://meet.google.com/" + code;
    },
    extensionAdjunto(nombre) {
      const match = String(nombre || "").match(/\.([a-z0-9]+)$/i);
      return match ? match[1].toLowerCase() : "";
    },
    iconoAdjunto(nombre) {
      const iconos = {
        pdf: "mdi-file-pdf-box",
        doc: "mdi-file-word-box",
        docx: "mdi-file-word-box",
        xls: "mdi-file-excel-box",
        xlsx: "mdi-file-excel-box",
        csv: "mdi-file-excel-box",
        ppt: "mdi-file-powerpoint-box",
        pptx: "mdi-file-powerpoint-box",
        zip: "mdi-folder-zip",
        rar: "mdi-folder-zip",
        jpg: "mdi-file-image",
        jpeg: "mdi-file-image",
        png: "mdi-file-image",
        gif: "mdi-file-image"
      };
      return (
        iconos[this.extensionAdjunto(nombre)] || "mdi-file-document-outline"
      );
    },
    colorAdjunto(nombre) {
      const colores = {
        pdf: "red darken-2",
        doc: "blue darken-2",
        docx: "blue darken-2",
        xls: "green darken-2",
        xlsx: "green darken-2",
        csv: "green darken-2",
        ppt: "orange darken-2",
        pptx: "orange darken-2",
        zip: "amber darken-2",
        rar: "amber darken-2"
      };
      return colores[this.extensionAdjunto(nombre)] || "primary";
    },
    async abrirGuia() {
      const materiaId = this.claseSeleccionada?.materiaCodigo_id;
      if (!materiaId) {
        // Fallback al comportamiento anterior si no tenemos el ID de la materia
        const url = this.claseSeleccionada?.guia_didactica || this.cursoGoogleDriveUrl;
        if (url) window.open(url, "_blank");
        return;
      }

      this.guiaDialog = true;
      this.guiaLoading = true;
      this.guiaError = "";

      try {
        const res = await this.$API.get({
          url: `materia-codigo/contenido-json/${materiaId}`,
          data: {}
        });
        this.guiaContenido = res;
      } catch (error) {
        this.guiaError = "No se pudo cargar la guía de contenidos.";
      } finally {
        this.guiaLoading = false;
      }
    },
    descargarGuiaPdf() {
      const materiaId = this.claseSeleccionada?.materiaCodigo_id;
      if (!materiaId) return;
      
      const url = `${this.$API.routeApi}materia-codigo/contenido/${materiaId}?app=PUBLIC`;
      window.open(url, "_blank");
    },
    abrirBibliografia() {
      this.bibliografiaDialog = true;
    },
    abrirPastilla() {
      this.pastillaDialog = true;
    },
    abrirMeet() {
      // Priorizar link de la clase seleccionada
      let meetUrl = this.claseSeleccionada && this.claseSeleccionada.link_meet 
        ? this.claseSeleccionada.link_meet.trim() 
        : "";

      // Si no hay link de clase, usar link general de la materia
      if (!meetUrl) {
        meetUrl = this.linkMeetMateria ? this.linkMeetMateria.trim() : "";
      }
      
      // Fallback a construcción por código de Classroom
      if (!meetUrl && this.codClassRoomMateria) {
        meetUrl = this.linkMeet(this.codClassRoomMateria);
      }

      if (!meetUrl) return;

      this.logPerseverancia();
      
      if (meetUrl.startsWith("http")) {
        window.open(meetUrl, "_blank");
      } else {
        window.open(this.linkMeet(meetUrl), "_blank");
      }
    },
    async logPerseverancia() {
      await this.$API
        .get(
          {
            url: "alumno/setperseverancia"
          },
          false
        )
        .then(res => {
          if (!res.tieneBadge1) {
            if (res.registraBadge1) {
              this.$store.commit("tieneBadge1", res.registraBadge1);
            }
          }

          if (!res.tieneBadge2) {
            if (res.registraBadge2) {
              this.$store.commit("tieneBadge2", res.registraBadge2);
            }
          }

          if (!res.tieneBadge3) {
            if (res.registraBadge3) {
              this.$store.commit("tieneBadge3", res.registraBadge3);
            }
          }
          this.$store.commit("porcentaje1", res.porcentaje1);
          this.$store.commit("porcentaje2", res.porcentaje2);
          this.$store.commit("porcentaje3", res.porcentaje3);
        });
    },
    // --- NUEVOS MÉTODOS PARA ACTIVIDADES ---
    loadMathJax() {
      if (window.MathJax && window.MathJax.typesetPromise) {
        this.mathjaxLoaded = true;
        return;
      }

      window.MathJax = {
        tex: {
          inlineMath: [["\\(", "\\)"]],
          displayMath: [
            ["$$", "$$"],
            ["\\[", "\\]"]
          ],
          processEscapes: true
        },
        options: {
          skipHtmlTags: ["script", "noscript", "style", "textarea", "pre"]
        },
        startup: {
          typeset: false
        }
      };

      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-svg.js";
      script.id = "MathJax-script";
      script.async = true;
      script.onload = () => {
        this.mathjaxLoaded = true;
        this.triggerMathJax();
      };
      document.head.appendChild(script);
    },
    triggerMathJax() {
      this.$nextTick(() => {
        if (window.MathJax && window.MathJax.typesetPromise) {
          window.MathJax.typesetPromise().catch(err =>
            console.error("MathJax error:", err)
          );
        }
      });
    },
    etiquetaTipo(actividad) {
      const tipo = TIPOS_ACTIVIDAD[actividad.type];
      return tipo ? tipo.etiqueta : "";
    },
    consignaTipo(actividad) {
      const tipo = TIPOS_ACTIVIDAD[actividad.type];
      return tipo ? tipo.consigna : "";
    },
    // Copia local de las opciones, con el orden que el alumno va armando en
    // SEQUENCING. El barajado ya lo hizo el backend.
    getOpciones(actividad) {
      const id = actividad.id;
      if (this.shuffledOptionsMap[id]) return this.shuffledOptionsMap[id];

      const options = [...(actividad.options || [])];
      this.$set(this.shuffledOptionsMap, id, options);
      return options;
    },
    getMatchingPairs(actividad) {
      const key = `matching_${actividad.id}`;
      if (this.shuffledOptionsMap[key]) return this.shuffledOptionsMap[key];

      // left_items y right_items comparten el id del par: el backend corrige
      // comparando el id elegido contra el del propio item de la izquierda.
      const state = {
        left: [...(actividad.left_items || [])],
        right: [...(actividad.right_items || [])],
        matches: {}
      };
      this.$set(this.shuffledOptionsMap, key, state);
      return state;
    },
    moveSequence(actividad, index, direction) {
      const options = this.shuffledOptionsMap[actividad.id];
      if (!options) return;

      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= options.length) return;

      const temp = options[index];
      this.$set(options, index, options[newIndex]);
      this.$set(options, newIndex, temp);
      this.$forceUpdate();
    },
    // El front manda ids, no texto: no conoce la respuesta correcta, la compara
    // el backend.
    respuestaScormPayload(actividad) {
      const respuesta = this.respuestasActividades[actividad.id];

      switch (actividad.type) {
        case "SEQUENCING":
          return (this.shuffledOptionsMap[actividad.id] || []).map(o => o.id);

        case "MATCHING":
          return (
            (this.shuffledOptionsMap[`matching_${actividad.id}`] || {}).matches ||
            {}
          );

        case "MULTIPLE_CHOICE":
          return Array.isArray(respuesta) ? respuesta : [];

        case "FILL_IN_THE_BLANK":
          return Array.isArray(respuesta) ? respuesta : [];

        default:
          return respuesta;
      }
    },
    claseResultadoScorm(actividad) {
      if (actividad.es_correcta === null) {
        return "grey lighten-4 grey--text text--darken-2";
      }
      return actividad.es_correcta
        ? "success lighten-5 success--text"
        : "error lighten-5 error--text";
    },
    async verificarActividadScorm(actividad) {
      if (actividad.verificando) return;
      this.$set(actividad, "verificando", true);

      try {
        // showLoader = false: sin overlay ni el snackbar de "Accion realizada
        // con exito" en cada verificacion.
        const res = await this.$API.post(
          {
            url: `actividades-scorm/${actividad.id}/verificar`,
            data: { respuesta: this.respuestaScormPayload(actividad) }
          },
          false
        );

        const esCorrecta = res && res.is_correct !== undefined ? res.is_correct : null;
        let texto = "Revisa tu respuesta.";
        if (esCorrecta === true) texto = "¡Correcto!";
        if (esCorrecta === null) texto = "Esta actividad no se corrige automáticamente.";

        this.$set(actividad, "es_correcta", esCorrecta);
        this.$set(actividad, "resultado", texto);
        this.$set(actividad, "feedback", (res && res.feedback) || null);
      } catch (error) {
        this.$set(actividad, "es_correcta", null);
        this.$set(actividad, "resultado", "No se pudo verificar, intentá de nuevo.");
      } finally {
        this.$set(actividad, "verificando", false);
        this.triggerMathJax();
      }
    },
    parseFillInTheBlank(content) {
      const parts = content.split("[BLANK]");
      return parts;
    }
  },
  mounted() {
    this.cargarRespuestasAlumnoGuardadas();
    this.cargarClasesMateria();
    this.cargarCategoriasForoMateria();
    this.cargarForosMateria();
    this.generarActividadesRandom();
    this.loadMathJax();
  },
  beforeDestroy() {
    this.guardarProgresoVideo("paused");
    this.detenerMonitoreoProgreso();
  }
};
</script>

<style scoped>
.course-content-card {
  background: #f3f6fb;
}

.course-content-title {
  background: linear-gradient(135deg, #c0392b, #a93226);
  color: #fff;
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 700;
  margin-bottom: 10px;
}

/* Utilidades del design system de itoestepublic (src/css/style.css). Van acá y no
   en el style.css global para no cambiar el resto de la app. Sin variables CSS:
   el root usa v-frag, no queda un elemento .materia-detalle donde declararlas. */
.glass-card {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05),
    0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
  transition: all 0.3s ease !important;
}

.rounded-huge {
  border-radius: 24px !important;
}

.letter-spacing-1 {
  letter-spacing: 1px !important;
}

.modulo-header {
  background: #f1f5f9;
  color: #475569;
  border-radius: 12px;
  padding: 12px 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modulo-header:hover {
  background: #e2e8f0;
  color: #1e293b;
}

.modulo-header-active {
  background: #2563eb !important;
  color: #fff !important;
  box-shadow: 0 8px 16px -4px rgba(37, 99, 235, 0.15) !important;
  font-weight: 600;
}

.modulo-header-resumen {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fee2e2;
  font-size: 0.85rem;
  padding: 8px 12px;
  margin-left: 16px;
}

.modulo-header-resumen.modulo-header-active {
  background: #ef4444 !important;
  color: #fff !important;
}

.hero {
  min-height: 105px;
  background: linear-gradient(135deg, #0d47a1, #42a5f5);
}

.course-name {
  font-size: 1.08rem;
  font-weight: 700;
  line-height: 1.35;
  color: #183153;
  letter-spacing: 0.1px;
  max-width: 100%;
}

.course-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background: #f8fbff;
  border: 1px solid #d9e5f4;
  border-radius: 12px;
  padding: 10px 12px;
}

.detail-cta-btn {
  height: 36px !important;
  min-width: 210px;
  border-radius: 10px;
  padding: 0 14px !important;
  text-transform: none !important;
  font-size: 0.84rem !important;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #fff !important;
  background: #2D3436 !important;
  box-shadow: 0 6px 14px rgba(21, 101, 192, 0.22) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.detail-pdf-btn {
  height: 36px !important;
  border-radius: 10px;
  text-transform: none !important;
  font-weight: 600;
}

.detail-cta-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
  box-shadow: 0 10px 18px rgba(21, 101, 192, 0.28) !important;
}

.detail-cta-btn:active {
  transform: translateY(0);
}

.detail-cta-btn:focus-visible {
  outline: 2px solid #90caf9;
  outline-offset: 2px;
}

.detail-cta-btn .v-icon {
  margin-right: 6px !important;
}

.video-main {
  min-height: 320px;
}

.video-main-container {
  position: relative;
}

.foro-card {
  background: linear-gradient(135deg, #7cb342, #8bc34a);
}

.actividad-card {
  min-height: 250px;
}

.actividad-header {
  background: linear-gradient(135deg, #0f5f93, #1e78b7);
  color: #fff;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 0.9rem;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.border-bottom {
  border-bottom: 1px solid #eee;
}

.blank-input {
  border: none;
  border-bottom: 2px solid #1e78b7;
  width: 80px;
  text-align: center;
  margin: 0 5px;
  outline: none;
  font-weight: bold;
  color: #1e78b7;
  background-color: transparent;
}

.blank-input:focus {
  background-color: #f5f5f5;
}

.italic {
  font-style: italic;
}

.code-mini {
  white-space: pre-wrap;
  font-size: 12px;
}

.draggable-chip {
  cursor: grab;
}

.drop-row {
  background: #f8fbff;
  border: 1px solid #e2ebf5;
  border-radius: 8px;
  padding: 8px;
}

.drop-slot {
  min-height: 36px;
  border: 1px dashed #90a4ae;
  border-radius: 8px;
  padding: 6px 8px;
  background: #fff;
}

.ia-chat-wrap {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px;
}

.ia-bubble {
  border-radius: 10px;
  padding: 10px;
}

.ia-bubble-user {
  background: #e3f2fd;
  border: 1px solid #bbdefb;
}

.ia-bubble-assistant {
  background: #f1f8e9;
  border: 1px solid #dcedc8;
}

.ia-reply-text {
  white-space: pre-wrap;
  line-height: 1.45;
}

.video-item-active {
  background: #eef6ff;
}

.clase-detalle-html {
  max-height: 68vh;
  overflow: auto;
  padding: 20px;
  border: 1px solid #dde3ea;
  border-radius: 8px;
  background: #fcfdff;
  color: #1f2937;
  font-family: "Segoe UI", Roboto, Arial, sans-serif;
  font-size: 1rem;
  line-height: 1.7;
}

.clase-detalle-html ::v-deep * {
  font-family: inherit !important;
  line-height: inherit;
  box-sizing: border-box;
}

.clase-detalle-html ::v-deep h1,
.clase-detalle-html ::v-deep h2,
.clase-detalle-html ::v-deep h3,
.clase-detalle-html ::v-deep h4,
.clase-detalle-html ::v-deep h5,
.clase-detalle-html ::v-deep h6 {
  color: #111827;
  font-weight: 700;
  line-height: 1.35;
  margin: 1.1em 0 0.6em;
}

.clase-detalle-html ::v-deep h1 {
  font-size: 1.6rem;
}

.clase-detalle-html ::v-deep h2 {
  font-size: 1.35rem;
}

.clase-detalle-html ::v-deep h3 {
  font-size: 1.2rem;
}

.clase-detalle-html ::v-deep p {
  margin: 0 0 1em;
  color: #1f2937;
}

.clase-detalle-html ::v-deep ul,
.clase-detalle-html ::v-deep ol {
  margin: 0 0 1em;
  padding-left: 1.35em;
}

.clase-detalle-html ::v-deep li {
  margin-bottom: 0.35rem;
}

.clase-detalle-html ::v-deep a {
  color: #0b57d0;
  text-decoration: underline;
  text-underline-offset: 2px;
  overflow-wrap: anywhere;
}

.clase-detalle-html ::v-deep a:hover {
  color: #084298;
}

.clase-detalle-html ::v-deep blockquote {
  margin: 1em 0;
  padding: 10px 12px;
  border-left: 4px solid #cbd5e1;
  background: #f8fafc;
  color: #334155;
}

.clase-detalle-html ::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 0.75em auto;
  display: block;
}

.clase-detalle-html ::v-deep pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: #111827;
  color: #f9fafb;
  border-radius: 6px;
  padding: 12px;
  margin: 1em 0;
  font-size: 0.9rem;
  line-height: 1.55;
}

.clase-detalle-html ::v-deep code {
  background: #f3f4f6;
  border-radius: 4px;
  padding: 1px 4px;
  color: #1f2937;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono",
    monospace;
  font-size: 0.9em;
}

.clase-detalle-html ::v-deep pre code {
  background: transparent;
  padding: 0;
  color: inherit;
}

.clase-detalle-html ::v-deep table {
  width: 100%;
  display: block;
  overflow-x: auto;
  border-collapse: collapse;
  margin: 1em 0;
  background: #fff;
}

.clase-detalle-html ::v-deep th,
.clase-detalle-html ::v-deep td {
  border: 1px solid #e5e7eb;
  padding: 8px 10px;
  vertical-align: top;
}

.clase-detalle-html ::v-deep th {
  background: #f9fafb;
  color: #111827;
  font-weight: 700;
}

.clase-detalle-html ::v-deep strong {
  font-weight: 700;
}

.clase-detalle-html ::v-deep em {
  font-style: italic;
}

.clase-detalle-html ::v-deep hr {
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin: 1.2em 0;
}

@media (max-width: 1264px) {
  .materia-detalle .modulos-card {
    display: flex;
    flex-direction: column;
  }

  .materia-detalle .modulos-scroll {
    height: 248px;
    overflow-y: scroll;
    padding-right: 4px;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }
}

@media (max-width: 960px) {
  .materia-detalle .hero {
    min-height: 80px;
  }

  .materia-detalle .video-main {
    min-height: 230px;
  }

  .materia-detalle .foro-header {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 8px;
  }

  .materia-detalle .course-nav {
    gap: 8px;
  }

  .materia-detalle .course-nav-btn {
    flex: 1 1 0;
    min-width: 0;
  }
}

@media (max-width: 600px) {
  .materia-detalle .course-name {
    font-size: 0.98rem;
  }

  .materia-detalle .course-title-row {
    align-items: stretch;
    padding: 10px;
  }

  .materia-detalle .detail-cta-btn {
    width: 100%;
    justify-content: center;
    min-width: 0;
  }

  .materia-detalle .video-main {
    min-height: 190px;
  }

  .materia-detalle .course-nav {
    flex-direction: column;
  }

  .materia-detalle .course-nav-btn {
    width: 100%;
  }

  .materia-detalle .recursos-actions {
    display: flex;
    flex-direction: column;
  }

  .materia-detalle .recurso-btn {
    width: 100%;
    margin-right: 0 !important;
  }

  .materia-detalle .foro-item,
  .materia-detalle .drop-row {
    word-break: break-word;
  }

  .materia-detalle .clase-detalle-html {
    padding: 12px;
    font-size: 0.95rem;
    line-height: 1.7;
  }

  .materia-detalle .clase-detalle-html ::v-deep h1 {
    font-size: 1.36rem;
  }

  .materia-detalle .clase-detalle-html ::v-deep h2 {
    font-size: 1.2rem;
  }
}

.meet-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-left: 4px solid #f44336 !important;
}
.meet-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.2) !important;
  background-color: #fff8f8;
}
.guia-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-left: 4px solid #1976d2 !important;
}
.guia-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2) !important;
  background-color: #f0f7ff;
}
.bibliografia-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-left: 4px solid #2D3436 !important;
}
.bibliografia-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(167, 186, 56, 0.2) !important;
  background-color: #f9fbf0;
}
.bibliografia-card.disabled-card {
  cursor: not-allowed !important;
  opacity: 0.6;
  border-left: 4px solid #9e9e9e !important;
}
.bibliografia-card.disabled-card:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.modulo-header.disabled-card {
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}
.modulo-header.disabled-card:hover {
  background: #f1f5f9 !important;
  color: #475569 !important;
}
/* v-html: sin ::v-deep el scoped no alcanza al contenido inyectado */
.bibliografia-html {
  word-break: break-word;
  color: #374151;
}
.bibliografia-html ::v-deep a {
  color: var(--v-primary-base) !important;
  text-decoration: underline;
}
.bibliografia-html ::v-deep p {
  margin-bottom: 8px;
}
.bibliografia-html ::v-deep ul,
.bibliografia-html ::v-deep ol {
  padding-left: 20px;
  margin-bottom: 8px;
}
.bibliografia-html ::v-deep li {
  margin-bottom: 4px;
}

/* ESTILOS GUÍA DE CONTENIDO PREMIUM */
.guia-header {
  background: #2D3436;
}
.guia-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}
.op-80 {
  opacity: 0.8;
}
.guia-content {
  background: #fbfcfd;
}
.guia-table-wrapper {
  border: 1px solid #e1e8ef;
  border-radius: 12px;
  overflow: hidden;
  background: white;
}
.guia-table {
  width: 100%;
  border-collapse: collapse;
}
.guia-table th {
  background: #f1f5f9;
  color: #475569;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  padding: 12px 16px;
  border-bottom: 2px solid #e2e8f0;
}
.guia-table td {
  padding: 20px 16px;
  border-bottom: 1px solid #f1f5f9;
}
.guia-numero-cell {
  background: #f8fafc;
  color: #C9412B;
  font-size: 1.1rem;
}
.tema-titulo {
  color: #2c3e50;
  text-transform: uppercase;
}
.guia-subtemas-list {
  padding-left: 20px;
  color: #546e7a;
  font-size: 0.95rem;
}
.guia-subtemas-list li::marker {
  color: #C9412B;
}
.guia-footer {
  background: #ffffff;
}
.border-top {
  border-top: 1px solid #edf2f7;
}
</style>
